/**
 * Workshop booking wizard — venue → (waitlist | calendar/time) → multi-variant cart.
 * Pricing: window.resolveWorkshopPrice (workshop-booking.js).
 */
(function () {
  'use strict';

  var Flow = window.WorkshopBookingWizardCalendar || window.WorkshopCityFlow;
  var MONTHS = (Flow && Flow.MONTHS) || [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  var DOW_PICKER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DOW_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var VARIANT_ROW_MIN_PX = 86;
  var VARIANT_ROW_MIN_H_PX = 54;
  var VARIANT_GRID_GAP_PX = 4;
  var LiveApi = window.WorkshopCityEvents;
  var WizardLive = window.WorkshopBookingWizardLive;

  function getLiveApi() {
    return window.WorkshopCityEvents || LiveApi || null;
  }

  function getWizardLive() {
    return window.WorkshopBookingWizardLive || WizardLive || null;
  }

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = sid ? document.getElementById('WorkshopWizardData-' + sid) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  var WB_WORKSHOP_TYPES = ['mosaic', 'resin', 'ceramic', 'flower'];

  function workshopTypeFromText(text) {
    var raw = String(text || '')
      .toLowerCase()
      .trim();
    if (!raw) return '';
    for (var i = 0; i < WB_WORKSHOP_TYPES.length; i++) {
      var t = WB_WORKSHOP_TYPES[i];
      if (raw === t || raw.indexOf(t) !== -1) return t;
    }
    return '';
  }

  function fetchWorkshopTypeFromProduct(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve('');
    if (!window.__WB_WORKSHOP_TYPE_BY_HANDLE) window.__WB_WORKSHOP_TYPE_BY_HANDLE = Object.create(null);
    if (window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] != null) {
      return Promise.resolve(window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        var tags = [];
        if (product && product.tags) {
          if (Array.isArray(product.tags)) tags = product.tags;
          else {
            tags = String(product.tags)
              .split(',')
              .map(function (t) {
                return String(t).trim();
              })
              .filter(Boolean);
          }
        }
        var found = '';
        for (var ti = 0; ti < tags.length; ti++) {
          found = workshopTypeFromText(tags[ti]);
          if (found) break;
        }
        if (!found) found = workshopTypeFromText(product && product.handle);
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = found;
        return found;
      })
      .catch(function () {
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = '';
        return '';
      });
  }

  function resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data) {
    var fromBooking = bookingRoot ? workshopTypeFromText(bookingRoot.getAttribute('data-workshop-type')) : '';
    if (fromBooking) return Promise.resolve(fromBooking);
    var fromWizard = wizardRoot ? workshopTypeFromText(wizardRoot.getAttribute('data-workshop-type')) : '';
    if (fromWizard) return Promise.resolve(fromWizard);
    if (data && data.workshopType) {
      var fromData = workshopTypeFromText(data.workshopType);
      if (fromData) return Promise.resolve(fromData);
    }
    var handle = '';
    if (data && data.productHandle) handle = String(data.productHandle).trim();
    if (!handle && wizardRoot) handle = String(wizardRoot.getAttribute('data-product-handle') || '').trim();
    if (!handle && bookingRoot) handle = String(bookingRoot.getAttribute('data-product-handle') || '').trim();
    var fromHandle = workshopTypeFromText(handle);
    if (fromHandle) return Promise.resolve(fromHandle);
    return fetchWorkshopTypeFromProduct(handle);
  }

  function parseSiblingPromoData(sectionId) {
    var el = sectionId ? document.getElementById('WorkshopSiblingPromoData-' + sectionId) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function siblingPromoScope(wizardRoot, sectionId) {
    var sid = sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id'));
    if (sid) {
      var section = document.getElementById('shopify-section-' + sid);
      if (section && section.querySelector('[data-wbw-sibling-promo-wrap]')) return section;
      var host = document.querySelector(
        '[data-workshop-sibling-promo][data-section-id="' +
          String(sid).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
          '"]'
      );
      if (host) return host.closest('.shopify-section') || host;
    }
    var near = wizardRoot && wizardRoot.closest('.shopify-section');
    if (near && near.querySelector('[data-wbw-sibling-promo-wrap]')) return near;
    return document;
  }

  function venueAddressScope(wizardRoot, sectionId) {
    var sid = sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id'));
    if (sid) {
      var section = document.getElementById('shopify-section-' + sid);
      if (section && section.querySelector('[data-wbw-venue-address-wrap]')) return section;
      var host = document.querySelector(
        '[data-workshop-venue-address][data-section-id="' +
          String(sid).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
          '"]'
      );
      if (host) return host.closest('.shopify-section') || host;
    }
    var near = wizardRoot && wizardRoot.closest('.shopify-section');
    if (near && near.querySelector('[data-wbw-venue-address-wrap]')) return near;
    return document;
  }

  var WB_SIBLING_HANDLE_FALLBACKS = {
    'mosaic-classess': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'mosaic-classes': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'ceramic-painting-classess': ['mosaic-classess', 'mosaic-classes'],
    'ceramic-painting-classes': ['mosaic-classess', 'mosaic-classes'],
  };

  var WB_SIBLING_LABELS = {
    'mosaic-classess': 'Mosaic Lamp Classes',
    'mosaic-classes': 'Mosaic Lamp Classes',
    'ceramic-painting-classess': 'Ceramic Painting Classes',
    'ceramic-painting-classes': 'Ceramic Painting Classes',
  };

  function parseVenueWorkshopIndex(sectionId) {
    var el = sectionId ? document.getElementById('WorkshopVenueWorkshopIndex-' + sectionId) : null;
    if (!el) return [];
    try {
      var rows = JSON.parse(el.textContent || '[]');
      return Array.isArray(rows) ? rows : [];
    } catch (_) {
      return [];
    }
  }

  function venueRefAliasKeys(id) {
    var keys = [];
    var seen = Object.create(null);
    function add(k) {
      k = String(k || '').trim();
      if (!k || seen[k]) return;
      seen[k] = true;
      keys.push(k);
    }
    var raw = String(id == null ? '' : id).trim();
    if (!raw) return keys;
    add(raw);
    add(normalizeVenueRefId(raw));
    var m = raw.match(/(\d+)\s*$/);
    if (m) {
      add(m[1]);
      add('gid://shopify/Metaobject/' + m[1]);
    }
    if (raw.indexOf('v_') === 0) add(raw);
    return keys;
  }

  function venueNameLookupKey(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function buildVenueWorkshopMaps(rows) {
    var byRef = Object.create(null);
    var byName = Object.create(null);
    (rows || []).forEach(function (row) {
      if (!row) return;
      var h = String(row.product_handle || '')
        .trim()
        .toLowerCase();
      if (!h) return;
      venueRefAliasKeys(row.venue_ref_id).forEach(function (vid) {
        if (!byRef[vid]) byRef[vid] = Object.create(null);
        byRef[vid][h] = true;
      });
      var nameKey = venueNameLookupKey(row.venue_name);
      if (nameKey) {
        if (!byName[nameKey]) byName[nameKey] = Object.create(null);
        byName[nameKey][h] = true;
      }
    });
    return { byRef: byRef, byName: byName };
  }

  function normalizeVenueRefId(id) {
    var s = String(id == null ? '' : id).trim();
    if (!s) return '';
    if (s.indexOf('gid://') === 0) return s;
    var m = s.match(/Metaobject\/(\d+)$/i);
    if (m) return 'gid://shopify/Metaobject/' + m[1];
    if (/^\d+$/.test(s)) return 'gid://shopify/Metaobject/' + s;
    return s;
  }

  function ensureSiblingWorkshops(list, productHandle) {
    var out = Array.isArray(list) ? list.slice() : [];
    if (out.length) return out;
    var current = String(productHandle || '')
      .trim()
      .toLowerCase();
    var fallbacks = WB_SIBLING_HANDLE_FALLBACKS[current] || [];
    for (var i = 0; i < fallbacks.length; i++) {
      var h = String(fallbacks[i] || '').trim();
      if (!h || h === current) continue;
      out.push({
        handle: h,
        title: WB_SIBLING_LABELS[h] || h,
        label: WB_SIBLING_LABELS[h] || h,
        url: '/products/' + encodeURIComponent(h),
        image: null,
      });
      break;
    }
    return out;
  }

  function collectAlsoAvailableHandles(source, out) {
    if (!source) return;
    var aa = source.also_available_products;
    if (!Array.isArray(aa)) return;
    aa.forEach(function (p) {
      var h = String((p && p.handle) || '')
        .trim()
        .toLowerCase();
      if (h) out[h] = true;
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (Flow && typeof Flow.formatMoney === 'function') return Flow.formatMoney(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function slotBookable(slot) {
    var liveApi = getLiveApi();
    if (liveApi && typeof liveApi.isSlotBookable === 'function') return liveApi.isSlotBookable(slot);
    if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.slotBookable === 'function') {
      return window.WorkshopCityFlow.slotBookable(slot);
    }
    if (Flow && Flow.slotBookable) return Flow.slotBookable(slot);
    if (!slot) return false;
    var st = String(slot.status || '').toLowerCase();
    if (st === 'sold_out' || st === 'cancelled') return false;
    var cap = slot.capacity_remaining;
    if (cap != null && cap !== '' && Number(cap) <= 0) return false;
    return true;
  }

  function formatSlotOptionText(slot) {
    if (!slot) return 'Session';
    var label = String(slot.time_label || '').trim();
    if (!label) {
      var dl = String(slot.display_label || '').trim();
      if (dl) {
        var pipe = dl.split('|');
        label = pipe.length > 1 ? pipe[pipe.length - 1].trim() : dl;
      }
    }
    if (!label) label = 'Session';
    if (!slotBookable(slot)) return label + ' — Sold out';
    return label;
  }

  function slotDateKey(slot) {
    if (Flow && Flow.slotDateKey) return Flow.slotDateKey(slot);
    if (!slot) return '';
    if (slot.date_key) return String(slot.date_key).slice(0, 10);
    if (slot.schema_start) return String(slot.schema_start).slice(0, 10);
    return '';
  }

  function toIsoDateKey(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    return '';
  }

  function normalizeEventToSlot(ev) {
    if (!ev || typeof ev !== 'object') return null;
    var status = String(ev.status || 'active').toLowerCase().replace(/\s+/g, '_');
    if (status !== 'sold_out' && status !== 'cancelled') status = 'active';

    var gid = ev.gid || ev.metaobject_gid || ev.event_metaobject_gid || '';
    if (!gid && ev.id != null) {
      var idStr = String(ev.id);
      gid = idStr.indexOf('gid://') === 0 ? idStr : 'gid://shopify/Metaobject/' + idStr;
    }

    var dateKey = toIsoDateKey(ev.date_key);
    if (!dateKey && ev.schema_start) dateKey = toIsoDateKey(ev.schema_start);
    if (!dateKey && ev.starts_at) dateKey = toIsoDateKey(ev.starts_at);

    var timeLabel = String(ev.time_label || '').trim();
    var displayLabel = String(ev.display_label || '').trim();
    if (!displayLabel) {
      displayLabel = dateKey || '';
      if (timeLabel) displayLabel = displayLabel ? displayLabel + ' | ' + timeLabel : timeLabel;
    }

    var capTot =
      ev.capacity_total != null && ev.capacity_total !== '' ? Number(ev.capacity_total) : null;
    if (!(capTot != null && Number.isFinite(capTot) && capTot > 0)) capTot = null;

    return {
      gid: gid,
      handle: String(ev.handle || ev.system_handle || ev.event_handle || ''),
      status: status,
      display_status:
        ev.display_status != null && ev.display_status !== ''
          ? String(ev.display_status).toLowerCase().replace(/\s+/g, '_')
          : '',
      capacity_remaining: ev.capacity_remaining != null ? ev.capacity_remaining : ev.capacity,
      capacity_total: capTot,
      variant_id: ev.variant_id != null ? ev.variant_id : ev.variantId,
      schema_start: ev.schema_start || ev.starts_at || '',
      schema_end: ev.schema_end || ev.ends_at || '',
      date_key: dateKey,
      time_label: timeLabel,
      display_label: displayLabel,
      _raw: ev,
    };
  }

  function eventsToSlots(events) {
    var out = [];
    (events || []).forEach(function (ev) {
      var s = normalizeEventToSlot(ev);
      if (s && s.date_key) out.push(s);
    });
    return out;
  }

  /** Match URL event_id (numeric or GID) to workshop event records. */
  function normalizeEventIdForMatch(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (s === '') return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return s;
  }

  function extractNumericEventIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function getEventIdFromUrl() {
    if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') {
      return String(window.__WB_INITIAL_EVENT_ID__).trim();
    }
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('event_id') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function normalizeVariantIdForMatch(val) {
    if (typeof window.__wbNormalizeVariantId === 'function') {
      return window.__wbNormalizeVariantId(val);
    }
    if (val == null) return '';
    var s = String(val).trim();
    if (s === '') return '';
    var gid = /^gid:\/\/shopify\/ProductVariant\/(\d+)$/i.exec(s);
    if (gid) return gid[1];
    if (/^\d+$/.test(s)) return s;
    return s;
  }

  function formatVariantIdForUrl(val) {
    if (typeof window.__wbFormatVariantIdForUrl === 'function') {
      return window.__wbFormatVariantIdForUrl(val);
    }
    return normalizeVariantIdForMatch(val);
  }

  function getVariantIdFromUrl() {
    if (window.__WB_INITIAL_VARIANT__ != null && String(window.__WB_INITIAL_VARIANT__).trim() !== '') {
      return normalizeVariantIdForMatch(window.__WB_INITIAL_VARIANT__);
    }
    try {
      var params = new URLSearchParams(window.location.search);
      return normalizeVariantIdForMatch(params.get('variant') || '');
    } catch (e) {
      return '';
    }
  }

  /** Sync ?variant= (numeric) & ?event_id= without changing pathname. */
  function updateWizardBookingUrl(patch) {
    if (!patch || typeof patch !== 'object') return;
    try {
      var params = new URLSearchParams(window.location.search);
      if ('eventId' in patch) {
        var numericEvent = extractNumericEventIdForUrl(patch.eventId);
        if (numericEvent) {
          params.set('event_id', numericEvent);
          window.__WB_URL_EVENT_ID_NUMERIC__ = numericEvent;
        } else {
          params.delete('event_id');
          window.__WB_URL_EVENT_ID_NUMERIC__ = '';
        }
      }
      if ('variantId' in patch) {
        var numericVar = normalizeVariantIdForMatch(patch.variantId);
        if (numericVar) {
          params.set('variant', numericVar);
          window.__WB_URL_VARIANT_NUMERIC__ = numericVar;
        } else {
          params.delete('variant');
          window.__WB_URL_VARIANT_NUMERIC__ = '';
        }
      }
      var qs = params.toString();
      var nextUrl = window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (e) {}
  }

  function eventRecordMatchesUrlEventId(ev, urlNumeric) {
    if (!ev || !urlNumeric) return false;
    var fields = [ev.id, ev.gid, ev.event_metaobject_gid, ev.metaobject_gid];
    for (var i = 0; i < fields.length; i++) {
      if (normalizeEventIdForMatch(fields[i]) === urlNumeric) return true;
    }
    return false;
  }

  function buildDaysMap(slots) {
    if (Flow && Flow.buildDaysMap) return Flow.buildDaysMap(slots, false);
    var map = {};
    (slots || []).forEach(function (s) {
      var dk = slotDateKey(s);
      if (!dk) return;
      if (!map[dk]) map[dk] = { bookable: false, any: true };
      if (slotBookable(s)) map[dk].bookable = true;
    });
    return map;
  }

  function wizardViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function calendarDowLabels() {
    return wizardViewportWidth() < 750 ? DOW_SHORT : DOW_PICKER;
  }

  function calDateKey(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function formatBookingSubLabel(slot) {
    if (!slot) return '';
    var dk = slot.date_key || '';
    var tl = String(slot.time_label || '').trim();
    if (dk && tl) return dk + ' | ' + tl;
    return dk || tl || '';
  }

  function vQtyKey(id) {
    return normalizeVariantIdForMatch(id);
  }

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function styleValueFromVariant(v, styleIdx) {
    if (!v) return '';
    if (styleIdx === 0) return v.option1 || '';
    if (styleIdx === 1) return v.option2 || '';
    return v.option3 || '';
  }

  function getSectionRoot(wizardRoot, data) {
    var sid = (data && data.sectionId) || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '';
    var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
    if (!sectionRoot && wizardRoot && wizardRoot.closest) {
      sectionRoot = wizardRoot.closest('[id^="shopify-section-"]');
    }
    return sectionRoot;
  }

  function isSessionOptionHandle(handle) {
    var h = String(handle || '').toLowerCase();
    return (
      h.indexOf('date') !== -1 ||
      h.indexOf('time') !== -1 ||
      h.indexOf('session') !== -1 ||
      h.indexOf('event') !== -1
    );
  }

  function parseVariantsJson(sectionRoot) {
    if (!sectionRoot) return [];
    var el = sectionRoot.querySelector('[data-variant-json]');
    if (!el || !el.textContent) return [];
    try {
      var list = JSON.parse(el.textContent);
      return Array.isArray(list) ? list : [];
    } catch (_) {
      return [];
    }
  }

  function ensureVariantMediaMeta(variant, sectionRoot, styleIdx) {
    if (!variant) return variant;
    if (variant.featured_media_id) return variant;
    var shopifyVariant = findShopifyVariantByWizard(
      sectionRoot,
      variant,
      styleIdx != null ? styleIdx : 0
    );
    if (shopifyVariant && shopifyVariant.featured_media && shopifyVariant.featured_media.id != null) {
      variant.featured_media_id = shopifyVariant.featured_media.id;
    }
    return variant;
  }

  function findShopifyVariantByWizard(sectionRoot, wizardVariant, styleIdx) {
    if (!sectionRoot || !wizardVariant) return null;
    var list = parseVariantsJson(sectionRoot);
    if (!list.length) return null;
    var idx = styleIdx != null ? Number(styleIdx) : 0;
    var styleVal = normalizeOptionValue(
      styleValueFromVariant(wizardVariant, idx) || wizardVariant.label || ''
    );
    var optKey = 'option' + (idx + 1);
    var i;
    for (i = 0; i < list.length; i++) {
      if (normalizeOptionValue(list[i][optKey]) === styleVal) return list[i];
    }
    for (i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(wizardVariant.id)) return list[i];
    }
    return null;
  }

  function findStyleFieldset(sectionRoot, styleIdx) {
    if (!sectionRoot) return null;
    var wraps = sectionRoot.querySelectorAll('.variant-input-wrap[data-handle]');
    var nonSession = [];
    var styleWrap = null;
    var i;
    for (i = 0; i < wraps.length; i++) {
      var handle = wraps[i].getAttribute('data-handle') || '';
      if (isSessionOptionHandle(handle)) continue;
      nonSession.push(wraps[i]);
      var idxAttr = wraps[i].getAttribute('data-index') || '';
      var num = parseInt(String(idxAttr).replace(/\D/g, ''), 10) - 1;
      if (num === styleIdx) styleWrap = wraps[i];
    }
    if (!styleWrap && nonSession.length) {
      styleWrap = nonSession[styleIdx] || nonSession[0];
    }
    return styleWrap;
  }

  function getProductContainer(sectionRoot, sectionId) {
    if (!sectionRoot) return null;
    if (sectionId) {
      var byId = sectionRoot.querySelector('#ProductSection-' + sectionId);
      if (byId) return byId;
    }
    return (
      sectionRoot.querySelector('[data-section-type="product"]') ||
      sectionRoot.querySelector('.product-section') ||
      sectionRoot
    );
  }

  function goToImpulseVariantMedia(sectionRoot, shopifyVariant) {
    if (!sectionRoot || !shopifyVariant) return false;
    var mediaId =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.id) ||
      shopifyVariant.featured_media_id;
    if (!mediaId && shopifyVariant.featured_image && shopifyVariant.featured_image.id) {
      mediaId = shopifyVariant.featured_image.id;
    }
    if (!mediaId) return false;

    var thumb = sectionRoot.querySelector(
      '.product__thumb[data-id="' + mediaId + '"], a.product__thumb[data-id="' + mediaId + '"]'
    );
    if (thumb) {
      thumb.click();
      return true;
    }

    var item = sectionRoot.querySelector('.product__thumb-item[data-index]');
    if (item) {
      var links = sectionRoot.querySelectorAll('.product__thumb-item a[data-product-thumb]');
      for (var i = 0; i < links.length; i++) {
        if (String(links[i].getAttribute('data-id')) === String(mediaId)) {
          links[i].click();
          return true;
        }
      }
    }
    return false;
  }

  function syncImpulseStyleOption(sectionRoot, styleIdx, styleVal) {
    if (!sectionRoot || !styleVal) return false;
    var fieldset = findStyleFieldset(sectionRoot, styleIdx);
    if (!fieldset) return false;
    var want = normalizeOptionValue(styleVal);
    var inputs = fieldset.querySelectorAll('[data-variant-input]');
    var target = null;
    inputs.forEach(function (input) {
      if (normalizeOptionValue(input.value) === want) target = input;
    });
    if (!target) return false;
    inputs.forEach(function (input) {
      input.checked = input === target;
    });
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function syncVariantToPdp(wizardRoot, data, variant) {
    if (!variant) return;
    var sectionRoot = getSectionRoot(wizardRoot, data);
    if (!sectionRoot) return;
    var sectionId = (data && data.sectionId) || wizardRoot.getAttribute('data-section-id') || '';
    var styleIdx =
      data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
    var styleVal =
      styleValueFromVariant(variant, styleIdx) || variant.label || '';
    var productEl = getProductContainer(sectionRoot, sectionId);
    var shopifyVariant = findShopifyVariantByWizard(sectionRoot, variant, styleIdx);

    if (productEl && styleVal) {
      syncImpulseStyleOption(productEl, styleIdx, styleVal);
    }

    variant = ensureVariantMediaMeta(variant, sectionRoot, styleIdx);
    if (shopifyVariant) {
      goToImpulseVariantMedia(sectionRoot, shopifyVariant);
      window.setTimeout(function () {
        goToImpulseVariantMedia(sectionRoot, shopifyVariant);
      }, 120);
    } else if (variant.featured_media_id) {
      goToImpulseVariantMedia(sectionRoot, {
        featured_media: { id: variant.featured_media_id },
      });
    }
  }

  var timeDdPortalEl = null;
  var WBW_TIME_DD_Z = 28;

  function cleanupOrphanTimeDdPanels() {
    document.querySelectorAll('[data-wbw-time-dd-portal]').forEach(function (el) {
      el.remove();
    });
    timeDdPortalEl = null;
  }

  function ensureTimeDdPortal() {
    if (!timeDdPortalEl || !timeDdPortalEl.parentNode) {
      timeDdPortalEl = document.createElement('div');
      timeDdPortalEl.className = 'wbw-time-dd-portal';
      timeDdPortalEl.setAttribute('data-wbw-time-dd-portal', '');
      document.body.appendChild(timeDdPortalEl);
    }
    return timeDdPortalEl;
  }

  function getCalTimeDdParts(root) {
    var dd = root.querySelector('[data-wbw-cal-time-dd]');
    if (!dd) return null;
    var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
    var panel = dd.querySelector('[data-wbw-cal-time-dd-panel]');
    if (!panel && timeDdPortalEl) {
      panel = timeDdPortalEl.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    if (!panel) {
      var portal = document.querySelector('[data-wbw-time-dd-portal]');
      if (portal) panel = portal.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    return { dd: dd, btn: btn, panel: panel };
  }

  function positionTimeDdPanel(parts) {
    if (!parts || !parts.panel || !parts.btn) return;
    var rect = parts.btn.getBoundingClientRect();
    var panel = parts.panel;
    var gap = 6;
    var maxH = 240;
    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    var openUp = spaceBelow < 120 && spaceAbove > spaceBelow;
    var avail = openUp ? spaceAbove : spaceBelow;
    panel.style.position = 'fixed';
    panel.style.left = rect.left + 'px';
    panel.style.width = Math.max(rect.width, 200) + 'px';
    panel.style.right = 'auto';
    panel.style.margin = '0';
    panel.style.zIndex = String(WBW_TIME_DD_Z);
    panel.style.maxHeight = Math.min(maxH, Math.max(80, avail - 8)) + 'px';
    if (openUp) {
      panel.style.top = 'auto';
      panel.style.bottom = window.innerHeight - rect.top + gap + 'px';
    } else {
      panel.style.bottom = 'auto';
      panel.style.top = rect.bottom + gap + 'px';
    }
  }

  function resetTimeDdPanelStyle(panel) {
    if (!panel) return;
    panel.style.position = '';
    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.left = '';
    panel.style.width = '';
    panel.style.right = '';
    panel.style.maxHeight = '';
    panel.style.zIndex = '';
    panel.style.margin = '';
  }

  function bindTimeDdReposition(wizardRoot) {
    if (wizardRoot.__wbwTimeDdReflowBound) return;
    wizardRoot.__wbwTimeDdReflowBound = true;
    function onReflow() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.dd.classList.contains('is-open')) return;
      if (parts.panel && !parts.panel.hidden) positionTimeDdPanel(parts);
    }
    window.addEventListener('resize', onReflow, { passive: true });
    window.addEventListener('scroll', onReflow, { passive: true, capture: true });
  }

  function wbwEmitVenueReset(bookingRoot) {
    try {
      document.dispatchEvent(
        new CustomEvent('wbw:venue-reset', { detail: { bookingRoot: bookingRoot || null } })
      );
    } catch (_) {}
  }

  function bindWizardSearchLayout(bookingRoot) {
    if (!bookingRoot || bookingRoot.__wbwSearchLayoutBound) return;
    bookingRoot.__wbwSearchLayoutBound = true;

    function injectPlaceShadowStyles(place) {
      if (!place || !place.shadowRoot) return;
      var styleId = 'wbw-place-autocomplete-styles';
      if (place.shadowRoot.getElementById(styleId)) return;
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        ':host {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  display: block !important;',
        '  width: 100% !important;',
        '}',
        'svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], slot[name="icon"], [slot="input-icon"] {',
        '  display: none !important;',
        '  width: 0 !important;',
        '  height: 0 !important;',
        '  opacity: 0 !important;',
        '  pointer-events: none !important;',
        '}',
        'input, input:focus, input:focus-visible {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  appearance: none !important;',
        '  -webkit-appearance: none !important;',
        '}',
        'div, form, [class*="container"], [class*="wrapper"], [class*="input"], [class*="field"] {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '}',
        '*:focus, *:focus-within, *:focus-visible {',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '}'
      ].join('\n');
      place.shadowRoot.appendChild(style);
    }

    function styleGooglePlaceField(place) {
      if (!place) return;
      try {
        place.setAttribute('no-input-icon', '');
        place.noInputIcon = true;
      } catch (_) {}
      try {
        place.style.setProperty('color-scheme', 'light');
        place.style.setProperty('border', 'none');
        place.style.setProperty('border-radius', '0');
        place.style.setProperty('--gmp-mat-color-surface', 'transparent');
        place.style.setProperty('--gmp-mat-color-on-surface', '#111827');
        place.style.setProperty('--gmp-mat-color-on-surface-variant', '#6b7280');
        place.style.setProperty('outline', 'none');
        place.style.setProperty('box-shadow', 'none');
        place.style.setProperty('background', 'transparent');
        place.style.setProperty('background-color', 'transparent');
      } catch (_) {}
      injectPlaceShadowStyles(place);
      try {
        if (place.shadowRoot) {
          place.shadowRoot.querySelectorAll('label, [class*="label"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
          });
          place.shadowRoot.querySelectorAll('svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], [slot="input-icon"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('width', '0', 'important');
            el.style.setProperty('height', '0', 'important');
            el.style.setProperty('opacity', '0', 'important');
          });
          place.shadowRoot.querySelectorAll('*').forEach(function (el) {
            try {
              el.style.setProperty('border', 'none', 'important');
              el.style.setProperty('outline', 'none', 'important');
              el.style.setProperty('box-shadow', 'none', 'important');
            } catch (_) {}
          });
        }
        var inner = place.shadowRoot && place.shadowRoot.querySelector('input');
        if (inner) {
          inner.style.setProperty('width', '100%');
          inner.style.setProperty('min-height', '52px');
          inner.style.setProperty('height', '52px');
          inner.style.setProperty('box-sizing', 'border-box');
          inner.style.setProperty('padding-left', '0');
          inner.style.setProperty('padding-right', '0');
          inner.style.setProperty('border', 'none');
          inner.style.setProperty('outline', 'none');
          inner.style.setProperty('background', 'transparent');
          inner.style.setProperty('box-shadow', 'none');
          inner.style.setProperty('font-size', '15px');
          inner.style.setProperty('line-height', '52px');
          if (!inner.getAttribute('placeholder')) {
            inner.setAttribute('placeholder', 'Search city or area');
          }
        }
      } catch (_) {}
    }

    function bindSearchTrigger(wrap) {
      if (!wrap) return;
      var btn = wrap.querySelector('[data-workshop-search-default]');
      if (!btn || btn.__wbwSearchTriggerBound) return;
      btn.__wbwSearchTriggerBound = true;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (typeof bookingRoot.__wbTriggerDefaultPrefetch === 'function') {
          bookingRoot.__wbTriggerDefaultPrefetch({ force: true });
          return;
        }
        try {
          bookingRoot.dispatchEvent(new CustomEvent('wbw:search-default', { bubbles: true }));
        } catch (_) {}
      });
    }

    function apply() {
      var panel = bookingRoot.querySelector('.wb-search-panel');
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (!wrap) return;
      var anchor = panel || wrap;
      var rect = anchor.getBoundingClientRect();
      var w = rect.width || wrap.getBoundingClientRect().width;

      var place = wrap.querySelector('gmp-place-autocomplete,[data-workshop-place-autocomplete],.wbw-search-place-host');
      var nativeInput = wrap.querySelector('#workshop-location-input');

      if (place) {
        wrap.classList.add('wbw-search-has-place');
        styleGooglePlaceField(place);
        if (nativeInput) nativeInput.classList.add('wbw-search-native-hidden');
      } else {
        wrap.classList.remove('wbw-search-has-place');
        if (nativeInput) nativeInput.classList.remove('wbw-search-native-hidden');
      }

      if (w) {
        try {
          document.querySelectorAll('.pac-container').forEach(function (pac) {
            pac.style.width = w + 'px';
            pac.style.minWidth = w + 'px';
            pac.style.maxWidth = w + 'px';
            if (rect.left) pac.style.left = rect.left + window.scrollX + 'px';
          });
        } catch (_) {}
      }

      bindSearchTrigger(wrap);
    }

    bookingRoot.addEventListener('wbw:places-mounted', apply);
    apply();
    window.addEventListener('resize', apply, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (wrap) {
        var ro = new ResizeObserver(apply);
        ro.observe(wrap);
        bookingRoot.__wbwSearchRo = ro;
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        apply();
      });
      mo.observe(bookingRoot, { childList: true, subtree: true });
      bookingRoot.__wbwSearchMo = mo;
    }
    window.setTimeout(apply, 400);
    window.setTimeout(apply, 1200);
    window.setTimeout(apply, 2500);
    window.setTimeout(apply, 5000);
  }

  function bindAddonHoverPreview(wizardRoot) {
    var card = wizardRoot.querySelector('[data-wbw-addon-card]');
    var popup = wizardRoot.querySelector('[data-wbw-addon-preview]');
    if (!card || !popup || card.__wbwAddonPreviewBound) return;
    card.__wbwAddonPreviewBound = true;

    document.querySelectorAll('[data-wbw-addon-preview]').forEach(function (el) {
      if (el !== popup) el.remove();
    });
    if (popup.parentElement !== document.body) document.body.appendChild(popup);

    var hoverTimer = null;
    var mobileCloseTimer = null;
    var visible = false;
    var lastEvent = null;
    var hoverMs = 500;
    var mobilePreviewMs = 2000;

    function clearMobileAutoClose() {
      if (mobileCloseTimer) {
        clearTimeout(mobileCloseTimer);
        mobileCloseTimer = null;
      }
    }

    function hidePreview() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
      clearMobileAutoClose();
      visible = false;
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    }

    function positionPreview(e) {
      var ev = e || lastEvent;
      if (!ev) return;
      lastEvent = ev;
      var x = ev.clientX != null ? ev.clientX : 0;
      var y = ev.clientY != null ? ev.clientY : 0;
      popup.style.left = x + 14 + 'px';
      popup.style.top = y + 14 + 'px';
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      var rect = popup.getBoundingClientRect();
      var pad = 8;
      if (rect.right > window.innerWidth - pad) {
        popup.style.left = Math.max(pad, window.innerWidth - rect.width - pad) + 'px';
      }
      if (rect.bottom > window.innerHeight - pad) {
        popup.style.top = Math.max(pad, window.innerHeight - rect.height - pad) + 'px';
      }
    }

    function positionPreviewMobile() {
      var rect = card.getBoundingClientRect();
      var pad = 8;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      var pw = popup.offsetWidth || 200;
      var ph = popup.offsetHeight || 120;
      var left = rect.left + rect.width / 2 - pw / 2;
      var top = rect.top - ph - pad;
      if (top < pad) top = rect.bottom + pad;
      if (left < pad) left = pad;
      if (left + pw > window.innerWidth - pad) {
        left = Math.max(pad, window.innerWidth - pw - pad);
      }
      if (top + ph > window.innerHeight - pad) {
        top = Math.max(pad, window.innerHeight - ph - pad);
      }
      popup.style.left = left + 'px';
      popup.style.top = top + 'px';
    }

    function showMobilePreview(e) {
      visible = true;
      if (e && (e.clientX || e.clientY)) positionPreview(e);
      else positionPreviewMobile();
      clearMobileAutoClose();
      mobileCloseTimer = window.setTimeout(function () {
        mobileCloseTimer = null;
        hidePreview();
      }, mobilePreviewMs);
    }

    card.__wbwShowMobilePreview = showMobilePreview;

    card.addEventListener('mouseenter', function (e) {
      if (isMobileViewport()) return;
      lastEvent = e;
      if (hoverTimer) clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(function () {
        hoverTimer = null;
        visible = true;
        positionPreview(e);
      }, hoverMs);
    });
    card.addEventListener('mousemove', function (e) {
      if (isMobileViewport()) return;
      lastEvent = e;
      if (visible) positionPreview(e);
    });
    card.addEventListener('mouseleave', function () {
      if (isMobileViewport()) return;
      hidePreview();
    });

    var mobilePreviewTapAt = 0;

    card.addEventListener(
      'touchend',
      function (e) {
        if (!isMobileViewport()) return;
        if (e.target.closest('[data-wbw-qty-inc], [data-wbw-qty-dec]')) return;
        lastEvent = e;
        mobilePreviewTapAt = Date.now();
        showMobilePreview(e);
      },
      { passive: true }
    );

    card.addEventListener(
      'click',
      function (e) {
        if (!isMobileViewport()) return;
        if (e.target.closest('[data-wbw-qty-inc], [data-wbw-qty-dec]')) return;
        if (Date.now() - mobilePreviewTapAt < 450) return;
        lastEvent = e;
        showMobilePreview(e);
      },
      { passive: true }
    );
  }

  function venueHasBookableEvents(venue) {
    var evs = venue && Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      var s = normalizeEventToSlot(evs[i]);
      if (s && s.date_key && slotBookable(s)) return true;
    }
    return false;
  }

  function venueIsWaitlistOnly(venue, card) {
    if (card && card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    if (venue && venue._wbWaitlistVenue === true) return true;
    return !venueHasBookableEvents(venue);
  }

  function variantCardLayout(root) {
    var layout = root && root.getAttribute('data-wbw-variant-layout');
    return layout === 'horizontal' ? 'horizontal' : 'stacked';
  }

  function wbwAddonDisplayTitle(root) {
    var t = (root && root.getAttribute('data-addon-title')) || 'Turkish Coffee';
    t = String(t).trim();
    t = t.replace(/^traditional\s+/i, '').trim();
    return t || 'Turkish Coffee';
  }

  function isMobileViewport() {
    return wizardViewportWidth() < 750;
  }

  function isDesktopViewport() {
    return wizardViewportWidth() >= 990;
  }

  function variantGridColsCap(root, count, width) {
    var useDesktop = wizardViewportWidth() >= 990;
    var raw = root.getAttribute(useDesktop ? 'data-wbw-cols-desktop' : 'data-wbw-cols-mobile');
    var n = parseInt(String(raw), 10);
    var cap = useDesktop ? 4 : 3;
    if (Number.isFinite(n) && n >= 2) cap = Math.min(5, n);
    if (!useDesktop && width > 0 && width < 300) cap = Math.min(cap, 3);
    return Math.min(count, cap);
  }

  function pickStackedGridColumns(count, width, height, gap, root) {
    var cap = variantGridColsCap(root, count, width);
    var minColPx = wizardViewportWidth() >= 990 ? 72 : 64;
    while (cap > 2 && width > 0 && cap * minColPx > width + 6) cap -= 1;
    return Math.max(1, cap);
  }

  function variantGridGapPx() {
    if (isDesktopViewport()) return 2;
    return 4;
  }

  function stackedThumbPx(cols, width, height, count, gap, wizardRoot) {
    var mobile = isMobileViewport();
    var desktop = isDesktopViewport();
    var rows = Math.ceil(count / cols);
    var g = gap >= 0 ? gap : variantGridGapPx();
    var colW = width > 0 ? (width - g * Math.max(0, cols - 1)) / cols : 100;
    var inWizard =
      wizardRoot &&
      wizardRoot.getAttribute &&
      wizardRoot.getAttribute('data-workshop-booking-wizard') != null;
    var qtyReserve = inWizard ? 0 : desktop ? 28 : 26;
    var innerPad = desktop ? 10 : 12;
    var cardW = Math.max(44, colW - qtyReserve);
    var thumbByW;
    if (desktop) {
      thumbByW = Math.max(44, Math.min(104, Math.floor(cardW - innerPad)));
      if (inWizard) thumbByW = Math.min(thumbByW, 112);
    } else {
      var maxThumb = mobile ? (inWizard ? 78 : 62) : 64;
      var minThumb = cols >= 4 ? 32 : 36;
      var colInset = mobile && inWizard ? 24 : 30;
      thumbByW = Math.max(minThumb, Math.min(maxThumb, Math.floor(colW - colInset)));
      if (inWizard) thumbByW = Math.min(thumbByW, mobile ? 98 : 88);
    }
    if (height <= 0 || rows <= 0) return thumbByW;
    var rowOverhead = desktop ? 32 : mobile && inWizard ? 26 : 34;
    var rowBudget = Math.floor((height - Math.max(0, rows - 1) * g) / rows) - rowOverhead;
    var minThumb = desktop ? 44 : cols >= 4 ? 32 : 36;
    return Math.max(minThumb, Math.min(thumbByW, rowBudget));
  }

  function pickVariantGridColumns(count, containerWidth, containerHeight, layout) {
    if (count <= 0) return 1;
    if (count === 1) return 1;
    layout = layout === 'horizontal' ? 'horizontal' : 'stacked';
    var width = containerWidth || 0;
    var height = containerHeight || 0;
    var gap = VARIANT_GRID_GAP_PX;
    var bestCols = 1;
    var bestScore = -Infinity;
    var minColPx = VARIANT_ROW_MIN_PX;
    var maxCols = count;

    if (width > 0) {
      if (layout === 'horizontal' && width < 990) {
        maxCols = Math.min(count, isMobileViewport() ? 2 : 3);
        minColPx = 110;
      } else if (width >= 420 && count >= 6) {
        maxCols = Math.min(count, 4);
      }
    }

    for (var cols = maxCols; cols >= 1; cols--) {
      if (width > 0 && cols * minColPx > width) continue;
      var rows = Math.ceil(count / cols);
      var needH = rows * VARIANT_ROW_MIN_H_PX + Math.max(0, rows - 1) * gap;
      if (height > 0 && needH > height) continue;
      var lastRow = count % cols || cols;
      var fullness = lastRow / cols;
      var score = fullness * 400 + cols * 28 - rows * 18;
      if (width >= 420 && count >= 6 && cols >= 4) score += 120;
      if (height > 0) score += (height - needH) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }
    return Math.max(1, bestCols);
  }

  function applyVariantGridLayout(wrap, count, wizardRoot) {
    if (!wrap || count < 1) return;
    var body = wrap.closest('.wcf-step__body--variants-booking');
    var w = wrap.clientWidth || 0;
    var h = 0;
    if (body) {
      h = body.clientHeight || 0;
      if (!h && body.getBoundingClientRect) h = body.getBoundingClientRect().height;
      if (!w) w = body.clientWidth || 0;
      var inWizardBody = wizardRoot && wizardRoot.contains(body);
      var bottomReserve = inWizardBody ? 172 : 0;
      var addonEl = body.querySelector('[data-wbw-addon-card]');
      if (addonEl) {
        var addonH = addonEl.offsetHeight || 0;
        if (!addonH && addonEl.getBoundingClientRect) addonH = addonEl.getBoundingClientRect().height;
        h = Math.max(0, h - addonH - 8);
      }
      if (inWizardBody) {
        var topEl = body.querySelector('.wbw-variants-booking-top');
        var topH = 0;
        if (topEl) {
          topH = topEl.clientHeight || 0;
          if (!topH && topEl.getBoundingClientRect) topH = topEl.getBoundingClientRect().height;
        }
        if (topH > 80) {
          h = topH;
        } else {
          var bottomEl = body.querySelector('.wbw-variants-booking-mid');
          if (!bottomEl) {
            var stepEl = body.closest('[data-wbw-step="variants"]');
            bottomEl = stepEl && stepEl.querySelector('.wbw-variant-step-foot');
          }
          if (bottomEl) {
            var bottomH = bottomEl.offsetHeight || 0;
            if (!bottomH && bottomEl.getBoundingClientRect) bottomH = bottomEl.getBoundingClientRect().height;
            bottomReserve = Math.max(bottomReserve, bottomH);
          }
          h = Math.max(120, h - bottomReserve);
        }
      }
    }
    if (!w && wrap.getBoundingClientRect) w = wrap.getBoundingClientRect().width;

    var layout = variantCardLayout(wizardRoot);
    var gap = layout === 'stacked' ? variantGridGapPx() : VARIANT_GRID_GAP_PX;
    var cols =
      layout === 'stacked'
        ? pickStackedGridColumns(count, w || 320, h, gap, wizardRoot)
        : pickVariantGridColumns(count, w || 320, h, layout);
    var rows = Math.ceil(count / cols);
    wrap.style.setProperty('--wcf-variant-cols', String(cols));
    wrap.style.setProperty('--wcf-variant-rows', String(rows));
    wrap.setAttribute('data-wcf-cols', String(cols));
    wrap.setAttribute('data-wcf-rows', String(rows));
    wrap.classList.toggle('wcf-variants--layout-stacked', layout === 'stacked');
    wrap.classList.toggle('wcf-variants--layout-horizontal', layout === 'horizontal');

    var compact = layout === 'horizontal' && w > 0 && w < 990;
    wrap.classList.toggle('wcf-variants--compact', compact);

    if (layout === 'stacked' && w > 0) {
      var thumbPx = stackedThumbPx(cols, w, h, count, gap, wizardRoot);
      wrap.style.setProperty('--wcf-variant-gap', gap + 'px');
      wrap.style.setProperty('--wcf-variant-thumb', thumbPx + 'px');
      wrap.setAttribute(
        'data-wcf-density',
        isMobileViewport() ? 'mobile' : isDesktopViewport() ? 'desktop' : 'tablet'
      );
      wrap.classList.remove('wcf-variants--fit');
    } else if (h > 0 && rows > 0 && !compact) {
      var rowH = Math.floor((h - Math.max(0, rows - 1) * gap) / rows);
      var rowMax = wizardRoot && wizardRoot.contains(wrap) ? 108 : 120;
      rowH = Math.max(VARIANT_ROW_MIN_H_PX, Math.min(rowH, rowMax));
      wrap.style.setProperty('--wcf-variant-title-size', rowH < 62 ? '0.5625rem' : rowH < 78 ? '0.625rem' : '0.6875rem');
      wrap.style.setProperty('--wcf-variant-price-size', rowH < 62 ? '0.6875rem' : '0.75rem');
      wrap.style.setProperty('--wcf-variant-pad', rowH < 58 ? '0.16rem' : '0.22rem');
      wrap.classList.add('wcf-variants--fit');
    } else {
      wrap.classList.remove('wcf-variants--fit');
    }
  }

  function bindVariantGridResize(wrap, wizardRoot) {
    if (!wrap) return;
    function relayout() {
      var n = wrap.querySelectorAll('.wcf-variant-row').length;
      if (n) applyVariantGridLayout(wrap, n, wizardRoot);
    }
    relayout();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        relayout();
        requestAnimationFrame(relayout);
      });
    }
    window.setTimeout(relayout, 60);
    if (typeof ResizeObserver === 'undefined') return;
    if (wrap.__wbwGridRo) wrap.__wbwGridRo.disconnect();
    var body = wrap.closest('.wcf-step__body--variants-booking');
    wrap.__wbwGridRo = new ResizeObserver(relayout);
    wrap.__wbwGridRo.observe(body || wrap);
    wrap.__wbwGridRo.observe(wrap);
  }

  function variantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    return (
      '<div class="wcf-qty wcf-qty--variant wcf-qty--horizontal wbw-qty-variant" data-wbw-variant-qty data-variant-id="' +
      id +
      '">' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-dec aria-label="Decrease quantity"' +
      (q <= 0 ? ' disabled' : '') +
      '>−</button>' +
      '<span class="wcf-qty__val" data-wbw-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-inc aria-label="Increase quantity">+</button></div>'
    );
  }

  function splitFullName(full) {
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { first: '', last: '' };
    return { first: parts[0], last: parts.slice(1).join(' ') || parts[0] };
  }

  function initRoot(wizardRoot) {
    if (!wizardRoot || wizardRoot.__wbwBound) return;
    wizardRoot.__wbwBound = true;
    cleanupOrphanTimeDdPanels();

    var data = parseData(wizardRoot);
    if (!data) return;

    var sectionId = data.sectionId || wizardRoot.getAttribute('data-section-id') || '';
    var venueWorkshopMaps = buildVenueWorkshopMaps(parseVenueWorkshopIndex(sectionId));
    var venueWorkshopMap = venueWorkshopMaps.byRef;
    var venueWorkshopMapByName = venueWorkshopMaps.byName;
    var siblingPromoData = parseSiblingPromoData(sectionId);
    var siblingWorkshops = ensureSiblingWorkshops(
      siblingPromoData && Array.isArray(siblingPromoData.siblingWorkshops)
        ? siblingPromoData.siblingWorkshops
        : [],
      data.productHandle || wizardRoot.getAttribute('data-product-handle')
    );
    var siblingPromoEyebrow = String(
      (siblingPromoData && siblingPromoData.siblingPromoEyebrow) || 'Also available as'
    ).trim();
    var promoScope = siblingPromoScope(wizardRoot, sectionId);
    var venueAddressBlockScope = venueAddressScope(wizardRoot, sectionId);

    var variants = Array.isArray(data.variants) ? data.variants.slice() : [];
    var bookingRoot = wizardRoot.querySelector('.pdp-workshop-booking');
    var eventsRoot = bookingRoot ? bookingRoot.querySelector('[data-workshop-events]') : null;
    var productId = String(data.productId || wizardRoot.getAttribute('data-product-id') || '');
    var urlDeepLinkMode = String(wizardRoot.getAttribute('data-wbw-url-deep-link-mode') || 'none').trim();
    var urlDeepLinkApplied = false;

    var state = {
      branch: 'venue',
      flow: 'booking',
      selectedVenueCard: null,
      selectedVenue: null,
      slotList: [],
      daysWithEvents: {},
      viewMonth: new Date(),
      selectedDate: '',
      selectedSlot: null,
      variantQty: {},
      addonQty: 0,
      focusedVariantId: '',
      lockedVariantId: vQtyKey(getVariantIdFromUrl()),
    };

    var liveHelper = getWizardLive();
    var liveController =
      liveHelper && typeof liveHelper.createController === 'function'
        ? liveHelper.createController(wizardRoot, {
            productHandle: data.productHandle || wizardRoot.getAttribute('data-product-handle') || '',
          })
        : null;
    var livePollStarted = false;

    function replaceSelectedSlotFromList(slots) {
      if (!state.selectedSlot || !Array.isArray(slots)) return;
      var key = String(
        (state.selectedSlot.gid || (state.selectedSlot._raw && state.selectedSlot._raw.id) || '')
      ).trim();
      if (!key) return;
      for (var i = 0; i < slots.length; i++) {
        var candidate = slots[i];
        if (!candidate) continue;
        var ckey = String((candidate.gid || (candidate._raw && candidate._raw.id) || '')).trim();
        if (ckey && ckey === key) {
          state.selectedSlot = candidate;
          return;
        }
      }
    }

    function applyLiveSlots(slots) {
      if (!Array.isArray(slots) || !slots.length) return;
      state.slotList = slots;
      state.daysWithEvents = buildDaysMap(state.slotList);
      replaceSelectedSlotFromList(state.slotList);
      if (state.branch === 'datetime') renderCalendar();
      else if (state.branch === 'variants') {
        renderVariants();
      }
      syncCapacityRing();
    }

    function ensureLivePoll() {
      if (!liveController || livePollStarted) return;
      if (typeof liveController.startPoll !== 'function') return;
      liveController.startPoll(
        function () {
          return state.slotList || [];
        },
        function (freshSlots) {
          applyLiveSlots(freshSlots || state.slotList || []);
        },
        { immediate: false }
      );
      livePollStarted = true;
    }

    function enrichSlotsForCurrentVenue(slots) {
      if (!liveController || typeof liveController.enrichSlots !== 'function') {
        return Promise.resolve(slots || []);
      }
      return liveController
        .enrichSlots(slots || [])
        .then(function (freshSlots) {
          return freshSlots || slots || [];
        })
        .catch(function () {
          return slots || [];
        });
    }

    var ALL_STEPS = ['venue', 'waitlist', 'datetime', 'variants'];

    function stepEl(name) {
      return wizardRoot.querySelector('[data-wbw-step="' + name + '"]');
    }

    function updateProgressLabels() {
      var total = 3;
      var labels = { venue: 1, waitlist: 1, datetime: 2, variants: 3 };
      wizardRoot.querySelectorAll('[data-wbw-progress]').forEach(function (p) {
        var step = state.branch;
        var n = labels[step] || 1;
        p.textContent = 'Step ' + n + ' of ' + total;
      });
      var venueFoot = stepEl('venue');
      if (venueFoot) {
        var solo = venueFoot.querySelector('[data-wbw-progress]');
        if (solo) solo.textContent = 'Step 1 of ' + total;
      }
    }

    function setBranch(branch) {
      if (branch !== 'datetime') closeCalTimeDd();
      state.branch = branch;
      window.__WB_LOCK_VARIANT_URL__ = branch === 'datetime';
      wizardRoot.setAttribute('data-wbw-branch', branch);
      ALL_STEPS.forEach(function (s) {
        var el = stepEl(s);
        if (!el) return;
        var on = s === branch;
        el.hidden = !on;
        el.classList.toggle('wcf-step--on', on);
      });
      updateProgressLabels();
      if (branch === 'datetime') syncCapacityRing();
      syncVenueAddressBlock();
      syncSiblingWorkshopPromo();
    }

    function venueProductHandles(venue) {
      var out = Object.create(null);
      if (!venue) return out;
      venueRefAliasKeys(venue.venue_ref_id).forEach(function (ref) {
        if (ref && venueWorkshopMap[ref]) {
          Object.keys(venueWorkshopMap[ref]).forEach(function (h) {
            out[h] = true;
          });
        }
      });
      var nameKey = venueNameLookupKey(venue.venue_name || venue.name || venue.city_name);
      if (nameKey && venueWorkshopMapByName[nameKey]) {
        Object.keys(venueWorkshopMapByName[nameKey]).forEach(function (h) {
          out[h] = true;
        });
      }
      var evs = Array.isArray(venue.events) ? venue.events : [];
      evs.forEach(function (ev) {
        if (!ev) return;
        var ph = String(ev.product_handle || ev.productHandle || '')
          .trim()
          .toLowerCase();
        if (ph) out[ph] = true;
        collectAlsoAvailableHandles(ev, out);
        var av = ev.available_variants;
        if (Array.isArray(av)) {
          av.forEach(function (it) {
            var h3 = String((it && (it.product_handle || it.productHandle)) || '')
              .trim()
              .toLowerCase();
            if (h3) out[h3] = true;
          });
        }
      });
      if (state.selectedSlot && state.selectedSlot._raw) {
        collectAlsoAvailableHandles(state.selectedSlot._raw, out);
      }
      return out;
    }

    function findSiblingWorkshopPromo(venue) {
      var current = String(data.productHandle || wizardRoot.getAttribute('data-product-handle') || '')
        .trim()
        .toLowerCase();
      if (!current || !siblingWorkshops.length) return null;
      var handles = venueProductHandles(venue);
      for (var i = 0; i < siblingWorkshops.length; i++) {
        var sib = siblingWorkshops[i];
        if (!sib || !sib.handle) continue;
        var h = String(sib.handle).trim().toLowerCase();
        if (h && h !== current && handles[h]) return sib;
      }
      return null;
    }

    function venueDisplayName(venue) {
      if (!venue) return '';
      var fromVenue = String(venue.venue_name || venue.name || venue.city_name || '').trim();
      if (fromVenue) return fromVenue;
      if (state.selectedVenueCard) {
        return String(state.selectedVenueCard.getAttribute('data-wbw-city-label') || '').trim();
      }
      return '';
    }

    function syncSiblingWorkshopPromo() {
      var wrap = promoScope.querySelector('[data-wbw-sibling-promo-wrap]');
      var link = promoScope.querySelector('[data-wbw-sibling-promo-link]');
      if (!wrap || !link) return;
      var show = state.branch === 'variants' && state.selectedVenue && state.flow === 'booking';
      var sibling = show ? findSiblingWorkshopPromo(state.selectedVenue) : null;
      if (!show || !sibling) {
        wrap.hidden = true;
        wrap.setAttribute('aria-hidden', 'true');
        link.hidden = true;
        return;
      }
      var venueName = venueDisplayName(state.selectedVenue);
      var sibHandle = String(sibling.handle || '')
        .trim()
        .toLowerCase();
      var label =
        String(sibling.label || sibling.title || '').trim() ||
        WB_SIBLING_LABELS[sibHandle] ||
        sibHandle;
      var titleText = venueName ? label + ' in ' + venueName : label;
      var eyebrowEl = promoScope.querySelector('[data-wbw-sibling-promo-eyebrow]');
      if (eyebrowEl) eyebrowEl.textContent = siblingPromoEyebrow || 'Also available as';
      var titleEl = promoScope.querySelector('[data-wbw-sibling-promo-title]');
      if (titleEl) titleEl.textContent = titleText;
      link.href = sibling.url || '/products/' + encodeURIComponent(sibling.handle);
      link.hidden = false;
      var img = promoScope.querySelector('[data-wbw-sibling-promo-img]');
      if (img) {
        if (sibling.image) {
          img.src = sibling.image;
          img.alt = label;
          img.hidden = false;
        } else {
          img.hidden = true;
          img.removeAttribute('src');
        }
      }
      wrap.hidden = false;
      wrap.setAttribute('aria-hidden', 'false');
    }

    function getPriceContext(slot) {
      var raw = (slot && slot._raw) || {};
      var venue = state.selectedVenue || {};
      return {
        eventId: String(raw.id || raw.gid || (slot && slot.gid) || '').trim(),
        state: String(raw.state || venue.state || '').trim(),
        city: String(raw.city || venue.city || venue.city_name || '').trim(),
        cityKey: String(raw.city_key || venue.city_key || '').trim(),
        venueName: String(raw.venue_name || raw.venue || venue.venue_name || venue.name || '').trim(),
        venueHandle: String(raw.venue_handle || venue.venue_handle || '').trim(),
      };
    }

    function resolveVariantPriceCents(variant, slot) {
      var base = Number(variant && variant.price) || 0;
      if (!slot || typeof window.resolveWorkshopPrice !== 'function') return base;
      var ctx = getPriceContext(slot);
      try {
        return window.resolveWorkshopPrice({
          basePriceCents: base,
          eventId: ctx.eventId,
          state: ctx.state,
          city: ctx.city,
          cityKey: ctx.cityKey,
          venueName: ctx.venueName,
          venueHandle: ctx.venueHandle,
          variantId: String(variant.id),
          workshopId: productId,
        });
      } catch (_) {
        return base;
      }
    }

    function venueLabelForWizard() {
      var card = state.selectedVenueCard;
      if (card) {
        var fromCard = String(card.getAttribute('data-wbw-city-label') || '').trim();
        if (fromCard) return fromCard;
      }
      var v = state.selectedVenue;
      if (!v) return '';
      return String(v.city_name || v.city || v.venue_name || v.name || '').trim();
    }

    function venueAddressForWizard() {
      var v = state.selectedVenue;
      if (v) {
        var fromVenue = String(v.venue_address || v.address || '').trim();
        if (fromVenue) return fromVenue;
      }
      var card = state.selectedVenueCard;
      if (card) {
        return String(card.getAttribute('data-venue-address') || '').trim();
      }
      return '';
    }

    function googleMapsUrlForVenueAddress(addr) {
      var address = String(addr || '').trim();
      if (!address) return '';
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
    }

    function syncVenueAddressBlock() {
      var wrap = venueAddressBlockScope.querySelector('[data-wbw-venue-address-wrap]');
      if (!wrap) return;
      var addr = venueAddressForWizard();
      var show = state.branch === 'datetime' && !!addr && state.flow === 'booking';
      var link = venueAddressBlockScope.querySelector('[data-wbw-venue-address-link]');
      var textEl = venueAddressBlockScope.querySelector('[data-wbw-venue-address-text]');
      if (textEl) textEl.textContent = show ? addr : '';
      if (link) {
        if (show) {
          link.href = googleMapsUrlForVenueAddress(addr);
          link.hidden = false;
          link.removeAttribute('aria-hidden');
          link.setAttribute('aria-label', 'Open venue address in Google Maps: ' + addr);
        } else {
          link.href = '#';
          link.hidden = true;
          link.setAttribute('aria-hidden', 'true');
          link.removeAttribute('aria-label');
        }
      }
      wrap.hidden = !show;
      wrap.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function updateBranchTitles() {
      var vn = venueLabelForWizard();
      var dt = stepEl('datetime');
      if (dt) {
        var calTitle = dt.querySelector('[data-wbw-cal-title]');
        if (calTitle) {
          calTitle.textContent = vn
            ? 'Select an Event Date for ' + vn
            : 'Select an Event Date';
        }
      }
      var wl = stepEl('waitlist');
      if (wl) {
        var wlTitle = wl.querySelector('[data-wbw-wl-title]');
        if (wlTitle) {
          wlTitle.textContent = vn
            ? 'No workshops scheduled for ' + vn + ' yet'
            : 'No workshops scheduled yet';
        }
      }
    }

    function updateVenueContinue() {
      var btn = wizardRoot.querySelector('[data-wbw-action="to-next"]');
      if (!btn) return;
      var card = state.selectedVenueCard;
      var valid =
        !!card &&
        !!state.selectedVenue &&
        state.flow !== 'waitlist' &&
        wizardRoot.contains(card) &&
        eventsRoot &&
        eventsRoot.contains(card);
      btn.disabled = !valid;
    }

    function syncVenueFlipState() {
      if (!eventsRoot) return;
      eventsRoot.querySelectorAll('.wbw-venue-flip-card').forEach(function (c) {
        c.classList.remove('wbw-venue-flipped');
      });
      var card = state.selectedVenueCard;
      if (
        card &&
        card.classList &&
        card.classList.contains('wbw-venue-flip-card') &&
        card.classList.contains('wbw-venue-selected') &&
        state.flow === 'waitlist'
      ) {
        card.classList.add('wbw-venue-flipped');
      }
    }

    function closeWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
    }

    function openWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      var vn = venueLabelForWizard();
      var title = modal.querySelector('[data-wbw-wl-modal-title]');
      if (title) {
        title.textContent = vn
          ? 'No workshops scheduled for ' + vn + ' yet'
          : 'No workshops scheduled yet';
      }
      var err = modal.querySelector('[data-wbw-wl-modal-error]');
      var ok = modal.querySelector('[data-wbw-wl-modal-success]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      if (ok) ok.hidden = true;
      ['[data-wbw-wl-modal-name]', '[data-wbw-wl-modal-email]', '[data-wbw-wl-modal-notes]'].forEach(function (sel) {
        var el = modal.querySelector(sel);
        if (el) el.value = '';
      });
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      var nameIn = modal.querySelector('[data-wbw-wl-modal-name]');
      try {
        if (nameIn) nameIn.focus();
      } catch (_) {}
    }

    function clearVenueSelection() {
      state.selectedVenueCard = null;
      state.selectedVenue = null;
      state.flow = 'booking';
      state.slotList = [];
      state.selectedDate = '';
      state.selectedSlot = null;
      state.lockedVariantId = vQtyKey(getVariantIdFromUrl());
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      closeWizardWaitlistModal();
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncVenueAddressBlock();
      syncSiblingWorkshopPromo();
    }

    function onVenueResetEvent(e) {
      var detail = (e && e.detail) || {};
      if (detail.bookingRoot && bookingRoot && detail.bookingRoot !== bookingRoot) return;
      urlDeepLinkApplied = false;
      clearVenueSelection();
    }

    function selectVenueCard(card, opts) {
      if (!card) return;
      var venue = card._wbVenue;
      if (!venue) return;
      opts = opts || {};

      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('wbw-venue-selected');
      card.setAttribute('aria-pressed', 'true');
      state.selectedVenueCard = card;
      state.selectedVenue = venue;
      state.flow = venueIsWaitlistOnly(venue, card) ? 'waitlist' : 'booking';
      wizardRoot.setAttribute('data-wbw-flow', state.flow);
      syncVenueFlipState();
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncVenueAddressBlock();
      syncSiblingWorkshopPromo();
      if (opts.autoAdvance && state.flow !== 'waitlist') {
        goToNextFromVenue();
      }
    }

    function bindVenueSelection() {
      if (!eventsRoot) return;
      eventsRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-wbw-wl-signup]')) {
          e.preventDefault();
          e.stopPropagation();
          var wlCard = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
          if (wlCard && wlCard._wbVenue) selectVenueCard(wlCard);
          openWizardWaitlistModal();
          return;
        }
        if (e.target.closest('[data-wb-waitlist-open]')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card)) return;
        if (!card._wbVenue) return;
        e.preventDefault();
        selectVenueCard(card, { autoAdvance: true });
      });
      eventsRoot.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.wb-venue-pick-card[role="button"], .wb-venue-card[role="button"]');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (e.target.closest('[data-wbw-wl-signup]')) return;
        e.preventDefault();
        selectVenueCard(card, { autoAdvance: true });
      });
      wizardRoot.querySelectorAll('[data-wbw-wl-modal-dismiss]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeWizardWaitlistModal();
        });
      });
      document.addEventListener('wbw:open-waitlist-modal', function (e) {
        var d = (e && e.detail) || {};
        if (d.bookingRoot && bookingRoot && d.bookingRoot !== bookingRoot) return;
        openWizardWaitlistModal();
      });
    }

    function slotsForDate(dateKey) {
      return state.slotList.filter(function (s) {
        return slotDateKey(s) === dateKey;
      });
    }

    function renderCalendar() {
      var step = stepEl('datetime');
      if (!step) return;
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth();
      var label = step.querySelector('[data-wbw-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;

      var dowEl = step.querySelector('[data-wbw-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = calendarDowLabels()
          .map(function (d) {
            return '<span class="wcf-cal-dow">' + d + '</span>';
          })
          .join('');
      }

      var grid = step.querySelector('[data-wbw-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
      for (var d = 1; d <= daysInMonth; d++) {
        var key = calDateKey(y, m, d);
        var info = state.daysWithEvents[key];
        var cls = 'wcf-cal-day';
        if (!info) cls += ' wcf-cal-day--muted';
        else {
          cls += ' wcf-cal-day--has-event';
          if (!info.bookable) cls += ' wcf-cal-day--soldout-only';
        }
        if (state.selectedDate === key) cls += ' wcf-cal-day--selected';
        var disabled = !info ? ' disabled' : '';
        html +=
          '<span class="wcf-cal-day-wrap"><button type="button" class="' +
          cls +
          '" data-wbw-cal-day="' +
          key +
          '"' +
          disabled +
          '>' +
          d +
          '</button></span>';
      }
      grid.innerHTML = html;
      renderTimeOptions();
    }

    /** Hub: load viewed month; always prefetch the following month in background. */
    function applyHubVenueEvents(events) {
      if (!Array.isArray(events) || !events.length) return;
      state.selectedVenue.events = events;
      var slots = eventsToSlots(events);
      if (!slots.length) return;
      state.slotList = slots;
      state.daysWithEvents = buildDaysMap(slots);
      if (state.branch === 'datetime') renderCalendar();
    }

    function prefetchHubNextMonth() {
      var HubCity = typeof window !== 'undefined' ? window.WorkshopBookingHubCity : null;
      if (!HubCity || typeof HubCity.ensureVenueMonthEvents !== 'function' || !state.selectedVenue) return;
      var ny = state.viewMonth.getFullYear();
      var nm = state.viewMonth.getMonth() + 2; // next month (1-based)
      if (nm > 12) {
        nm = 1;
        ny += 1;
      }
      HubCity.ensureVenueMonthEvents(state.selectedVenue, ny, nm).then(applyHubVenueEvents);
    }

    function ensureHubMonthThenRender() {
      renderCalendar();
      var HubCity = typeof window !== 'undefined' ? window.WorkshopBookingHubCity : null;
      if (
        !HubCity ||
        typeof HubCity.isHubBooking !== 'function' ||
        !HubCity.isHubBooking(bookingRoot) ||
        typeof HubCity.ensureVenueMonthEvents !== 'function' ||
        !state.selectedVenue
      ) {
        return;
      }
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth() + 1;
      HubCity.ensureVenueMonthEvents(state.selectedVenue, y, m).then(function (events) {
        applyHubVenueEvents(events);
        prefetchHubNextMonth();
      });
    }

    function closeCalTimeDd() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts) return;
      if (parts.panel) {
        parts.panel.hidden = true;
        parts.panel.setAttribute('hidden', '');
        resetTimeDdPanelStyle(parts.panel);
        parts.dd.appendChild(parts.panel);
      }
      if (parts.btn) parts.btn.setAttribute('aria-expanded', 'false');
      parts.dd.classList.remove('is-open');
    }

    function openCalTimeDd() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.panel || !parts.btn || parts.btn.disabled) return;
      bindTimeDdReposition(wizardRoot);
      ensureTimeDdPortal().appendChild(parts.panel);
      parts.panel.hidden = false;
      parts.panel.removeAttribute('hidden');
      parts.btn.setAttribute('aria-expanded', 'true');
      parts.dd.classList.add('is-open');
      positionTimeDdPanel(parts);
      var selected = parts.panel.querySelector('.wcf-cal-time__dd-opt.is-selected');
      if (selected && typeof selected.scrollIntoView === 'function') {
        selected.scrollIntoView({ block: 'nearest' });
      }
    }

    function syncCalTimeDdFromSelect(step) {
      var dd = step && step.querySelector('[data-wbw-cal-time-dd]');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!dd || !select) return;

      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || parts.dd !== dd) return;
      var btn = parts.btn;
      var panel = parts.panel;
      if (!btn || !panel) return;

      btn.disabled = select.disabled;
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      btn.textContent =
        hasValue && selectedOpt && selectedOpt.textContent
          ? selectedOpt.textContent
          : select.disabled
            ? 'No sessions this day'
            : 'Select a date first';
      btn.classList.toggle('is-placeholder', !hasValue);

      panel.innerHTML = '';

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', opt.value);
        item.textContent = opt.textContent;
        if (opt.selected) item.classList.add('is-selected');
        if (/sold out/i.test(opt.textContent)) item.classList.add('is-soldout');
        item.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        });
        item.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var gid = ev.currentTarget.getAttribute('data-gid');
          if (!gid) return;
          select.value = gid;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeCalTimeDd();
        });
        panel.appendChild(item);
      }
      if (!panel.__wbwPanelClickStop) {
        panel.__wbwPanelClickStop = true;
        panel.addEventListener('click', function (ev) {
          ev.stopPropagation();
        });
        panel.addEventListener('mousedown', function (ev) {
          ev.stopPropagation();
        });
      }
    }

    function onTimeSelectChange() {
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      if (!select) return;

      var gid = String(select.value || '').trim();
      if (!gid) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        clearBookingUrlEventIdKeepVariant();
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        return;
      }

      var daySlots = slotsForDate(state.selectedDate);
      var slot = null;
      for (var i = 0; i < daySlots.length; i++) {
        if (daySlots[i].gid === gid) {
          slot = daySlots[i];
          break;
        }
      }
      if (!slot || !slotBookable(slot)) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        clearBookingUrlEventIdKeepVariant();
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        return;
      }

      state.selectedSlot = slot;
      if (toBtn) toBtn.disabled = false;
      syncWorkshopSelection(slot);
      syncCalTimeDdFromSelect(step);
      syncCapacityRing();
    }

    function renderCalTimeNativeSelect(step, daySlots) {
      var select = step.querySelector('[data-wbw-time-select]');
      if (!select) return;

      if (!state.selectedDate) {
        select.disabled = true;
        select.innerHTML = '<option value="">Select a date first</option>';
        return;
      }

      select.innerHTML = '';

      if (!daySlots.length) {
        var emptyOpt = document.createElement('option');
        emptyOpt.value = '';
        emptyOpt.textContent = 'No sessions this day';
        select.appendChild(emptyOpt);
        select.disabled = true;
        state.selectedSlot = null;
        return;
      }

      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotOptionText(slot);
        select.appendChild(opt);
      });

      select.disabled = false;

      var defaultSlot = null;
      if (state.selectedSlot) {
        for (var i = 0; i < daySlots.length; i++) {
          if (daySlots[i].gid === state.selectedSlot.gid && slotBookable(daySlots[i])) {
            defaultSlot = daySlots[i];
            break;
          }
        }
      }
      if (!defaultSlot) {
        for (var j = 0; j < daySlots.length; j++) {
          if (slotBookable(daySlots[j])) {
            defaultSlot = daySlots[j];
            break;
          }
        }
      }

      if (defaultSlot && defaultSlot.gid) {
        select.value = defaultSlot.gid;
        onTimeSelectChange();
      } else {
        select.value = '';
        state.selectedSlot = null;
      }
    }

    function renderTimeOptions() {
      var step = stepEl('datetime');
      if (!step) return;
      var hint = step.querySelector('[data-wbw-cal-time-hint]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      var daySlots = slotsForDate(state.selectedDate).filter(slotBookable);

      renderCalTimeNativeSelect(step, daySlots);
      syncCalTimeDdFromSelect(step);
      closeCalTimeDd();

      if (hint) {
        if (state.selectedDate && !daySlots.length) {
          hint.textContent = 'Pick another date with a bold number.';
          hint.hidden = false;
        } else {
          hint.textContent = '';
          hint.hidden = true;
        }
      }

      if (!state.selectedSlot) {
        if (toBtn) toBtn.disabled = true;
      } else if (toBtn) {
        toBtn.disabled = false;
      }
      syncCapacityRing();
    }

    function bindCalTimeControls() {
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      if (select && !select.__wbwTimeBound) {
        select.__wbwTimeBound = true;
        select.addEventListener('change', onTimeSelectChange);
      }

      var dd = step.querySelector('[data-wbw-cal-time-dd]');
      if (!dd || dd.__wbwDdBound) return;
      dd.__wbwDdBound = true;
      var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parts = getCalTimeDdParts(wizardRoot);
        if (parts && parts.panel && !parts.panel.hidden) closeCalTimeDd();
        else openCalTimeDd();
      });

      if (!wizardRoot.__wbwCalTimeDdDocClose) {
        wizardRoot.__wbwCalTimeDdDocClose = true;
        document.addEventListener('click', function (e) {
          var parts = getCalTimeDdParts(wizardRoot);
          if (!parts || !parts.dd.classList.contains('is-open')) return;
          if (e.target.closest('[data-wbw-cal-time-dd]')) return;
          if (e.target.closest('[data-wbw-time-dd-portal]')) return;
          closeCalTimeDd();
        });
      }
    }

    function ensureLockedVariantFromUrlOrSlot(slot) {
      if (state.lockedVariantId) return;
      var fromUrl = getVariantIdFromUrl();
      if (fromUrl) {
        state.lockedVariantId = vQtyKey(fromUrl);
        return;
      }
      var raw = slot && slot._raw;
      if (raw && raw.variant_id != null && raw.variant_id !== '') {
        state.lockedVariantId = vQtyKey(raw.variant_id);
      }
    }

    function syncLockedVariantToPdp() {
      if (!state.lockedVariantId) return;
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (vQtyKey(variants[i].id) === state.lockedVariantId) {
          v = variants[i];
          break;
        }
      }
      if (v) syncVariantToPdp(wizardRoot, data, v);
    }

    function syncBookingUrlForDatetimeStep(slot) {
      if (state.branch !== 'datetime' || !slot) return;
      ensureLockedVariantFromUrlOrSlot(slot);
      var raw = slot._raw || {};
      var eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      var numericEvent = extractNumericEventIdForUrl(eventId);
      if (!numericEvent) return;
      var urlPatch = { eventId: numericEvent };
      if (state.lockedVariantId) {
        urlPatch.variantId = state.lockedVariantId;
        window.__WB_URL_VARIANT_NUMERIC__ = state.lockedVariantId;
      }
      updateWizardBookingUrl(urlPatch);
    }

    function syncBookingUrlVariantOnStep3(variantId) {
      if (state.branch !== 'variants') return;
      var id = vQtyKey(variantId);
      if (!id) return;
      window.__WB_URL_VARIANT_NUMERIC__ = id;
      updateWizardBookingUrl({ variantId: id });
    }

    function clearBookingUrlEventIdKeepVariant() {
      var patch = { eventId: null };
      if (state.lockedVariantId) patch.variantId = state.lockedVariantId;
      else {
        var fromUrl = getVariantIdFromUrl();
        if (fromUrl) patch.variantId = vQtyKey(fromUrl);
      }
      updateWizardBookingUrl(patch);
    }

    function syncWorkshopSelection(slot) {
      if (!slot) return;
      var raw = slot._raw || {};
      var eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      window.__WORKSHOP_SELECTION__ = {
        eventId: eventId,
        eventHandle: eventHandle,
        city: String(raw.city || '').trim(),
        state: String(raw.state || '').trim(),
        venue: String(raw.venue_name || raw.venue || (state.selectedVenue && state.selectedVenue.venue_name) || '').trim(),
        datetime: formatBookingSubLabel(slot),
      };
      try {
        document.dispatchEvent(new CustomEvent('wb:selection', { detail: window.__WORKSHOP_SELECTION__ }));
      } catch (_) {}
      syncBookingUrlForDatetimeStep(slot);
    }

    function startWaitlistStep() {
      var step = stepEl('waitlist');
      if (!step) return;
      updateBranchTitles();
      var err = step.querySelector('[data-wbw-wl-error]');
      var ok = step.querySelector('[data-wbw-wl-success]');
      if (err) err.hidden = true;
      if (ok) ok.hidden = true;
      setBranch('waitlist');
    }

    function startDatetimeStep(preselectedSlot) {
      if (!state.selectedVenue) return;
      ensureLockedVariantFromUrlOrSlot(preselectedSlot);
      syncLockedVariantToPdp();
      state.slotList = eventsToSlots(state.selectedVenue.events || []);
      function paintFromSlots(slotList, preferSlot) {
        state.slotList = slotList || [];
        state.daysWithEvents = buildDaysMap(state.slotList);
        var keys = Object.keys(state.daysWithEvents).sort();
        if (preferSlot && preferSlot.date_key) {
          state.selectedDate = slotDateKey(preferSlot);
          state.selectedSlot = preferSlot;
          var dp = state.selectedDate.split('-').map(Number);
          if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
        } else {
          state.selectedDate = '';
          state.selectedSlot = null;
          if (keys.length) {
            state.selectedDate = keys[0];
            var parts = keys[0].split('-').map(Number);
            if (parts.length >= 2) state.viewMonth = new Date(parts[0], parts[1] - 1, 1);
          }
        }
        updateBranchTitles();
        setBranch('datetime');
        renderCalendar();
        if (preferSlot && slotBookable(preferSlot)) {
          syncWorkshopSelection(preferSlot);
        }
        syncCapacityRing();
      }

      if (!state.slotList.length) {
        /* still try hub batch refresh below */
      } else {
        paintFromSlots(state.slotList, preselectedSlot);
      }

      var HubCity = typeof window !== 'undefined' ? window.WorkshopBookingHubCity : null;
      var hubRefresh =
        HubCity && typeof HubCity.refreshVenueEvents === 'function'
          ? HubCity.refreshVenueEvents(state.selectedVenue)
          : Promise.resolve(null);

      hubRefresh
        .then(function (freshEvents) {
          if (Array.isArray(freshEvents) && freshEvents.length) {
            state.selectedVenue.events = freshEvents;
            var freshSlots = eventsToSlots(freshEvents);
            if (freshSlots.length) {
              paintFromSlots(freshSlots, preselectedSlot || state.selectedSlot);
              ensureLivePoll();
              try {
                prefetchHubNextMonth();
              } catch (_) {}
              return freshSlots;
            }
          }
          return enrichSlotsForCurrentVenue(state.slotList);
        })
        .then(function (freshSlots) {
          if (!Array.isArray(freshSlots) || !freshSlots.length) return;
          if (!(state.selectedVenue.events && state.selectedVenue.events.length)) {
            applyLiveSlots(freshSlots);
          }
          ensureLivePoll();
        })
        .catch(function () {
          enrichSlotsForCurrentVenue(state.slotList).then(function (freshSlots) {
            if (!Array.isArray(freshSlots) || !freshSlots.length) return;
            applyLiveSlots(freshSlots);
            ensureLivePoll();
          });
        });

      ensureLivePoll();
      if (!state.slotList.length) {
        /* hub refresh may still fill; show datetime once we have keys */
        updateBranchTitles();
        setBranch('datetime');
        renderCalendar();
        return;
      }
    }

    function goToNextFromVenue() {
      if (
        !state.selectedVenue ||
        !state.selectedVenueCard ||
        !wizardRoot.contains(state.selectedVenueCard) ||
        (eventsRoot && !eventsRoot.contains(state.selectedVenueCard))
      ) {
        clearVenueSelection();
        return;
      }
      if (state.flow === 'waitlist') return;
      startDatetimeStep();
    }

    function totalVariantQty() {
      var n = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        n += state.variantQty[k] || 0;
      });
      return n;
    }

    function hasSelectedVariants() {
      return totalVariantQty() > 0;
    }

    /** Seats left for selected event — from capacity_remaining only (per event, no fixed cap). */
    function parseSlotCapacityRemaining(slot) {
      if (!slot) return null;
      var cap = slot.capacity_remaining;
      if (cap == null || cap === '') {
        var raw = slot._raw;
        if (raw && raw.capacity_remaining != null && raw.capacity_remaining !== '') {
          cap = raw.capacity_remaining;
        }
      }
      if (cap == null || cap === '') return null;
      var n = Number(cap);
      return Number.isFinite(n) ? n : null;
    }

    function maxBookableQty() {
      if (liveController && typeof liveController.maxBookableQty === 'function') {
        return liveController.maxBookableQty(state.selectedSlot);
      }
      if (!state.selectedSlot || !slotBookable(state.selectedSlot)) return 0;
      var cap = parseSlotCapacityRemaining(state.selectedSlot);
      if (cap == null) return 1;
      return cap > 0 ? cap : 0;
    }

    function formatWizardVariantPricesOuter(v, slotForPrice) {
      var slot = slotForPrice !== undefined ? slotForPrice : state.selectedSlot;
      var open = slotBookable(slot);
      var base = Number(v && v.price) || 0;
      var resolved = resolveVariantPriceCents(v, slot);
      if (!open) {
        return (
          '<div class="wcf-variant-card__prices">' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--current">' +
          escapeHtml(formatMoney(resolved)) +
          '</span></div>'
        );
      }
      if (resolved < base && base > 0) {
        return (
          '<div class="wcf-variant-card__prices wcf-variant-card__prices--discount">' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--compare">' +
          '<s>' +
          escapeHtml(formatMoney(base)) +
          '</s></span>' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--sale">' +
          escapeHtml(formatMoney(resolved)) +
          '</span></div>'
        );
      }
      return (
        '<div class="wcf-variant-card__prices">' +
        '<span class="wcf-variant-card__price wcf-variant-card__price--current">' +
        escapeHtml(formatMoney(resolved)) +
        '</span></div>'
      );
    }

    function capacityRingModel(slot) {
      if (!slot || !slotBookable(slot)) return null;
      var raw = slot._raw || {};
      var rem = Number(
        raw.capacity_remaining != null && raw.capacity_remaining !== ''
          ? raw.capacity_remaining
          : slot.capacity_remaining
      );
      var tot = Number(
        raw.capacity_total != null && raw.capacity_total !== '' ? raw.capacity_total : slot.capacity_total
      );
      if (Number.isFinite(rem) && rem >= 0 && (!(tot > 0) || !Number.isFinite(tot))) {
        /* events-batch thin slots may omit capacity_total until adapter ships it */
        return { rem: rem, tot: null, used: null, pctUsed: 0, pctRem: 100, remOnly: true };
      }
      if (!(tot > 0) || !Number.isFinite(rem) || rem < 0) return null;
      var used = Math.max(0, Math.min(tot, tot - rem));
      var pctUsed = (used / tot) * 100;
      pctUsed = Math.max(0, Math.min(100, pctUsed));
      var pctRem = (rem / tot) * 100;
      pctRem = Math.max(0, Math.min(100, pctRem));
      return { rem: rem, tot: tot, used: used, pctUsed: pctUsed, pctRem: pctRem, remOnly: false };
    }

    /** Tier by occupancy (booked %): empty event = green, nearly full = red. */
    function capacityRingTier(pctUsed) {
      var pct = Math.round(pctUsed);
      if (pct >= 100) return 'soldout';
      if (pct >= 66) return 'low';
      if (pct >= 33) return 'medium';
      return 'high';
    }

    function capacityRingAriaLabel(m) {
      if (!m) return 'Capacity — select a time to see availability';
      if (m.remOnly) return Math.round(m.rem) + ' spots left';
      if (!(m.tot > 0)) return 'Capacity — select a time to see availability';
      return (
        Math.round(m.used) +
        ' of ' +
        Math.round(m.tot) +
        ' spots booked, ' +
        (Math.round(m.pctUsed * 10) / 10) +
        ' percent full'
      );
    }

    function capacityRingPctText(m) {
      if (!m) return '';
      if (m.used <= 0) return '0%';
      if (m.used >= m.tot) return '100%';
      var tenths = Math.round(m.pctUsed * 10) / 10;
      return (tenths % 1 === 0 ? String(Math.round(tenths)) : tenths.toFixed(1)) + '%';
    }

    function syncCapacityRingEmpty(ring) {
      ring.hidden = false;
      ring.classList.add('is-empty');
      ring.setAttribute('data-capacity-tier', 'empty');
      ring.setAttribute('aria-label', 'Capacity — select a time to see availability');
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = '—';
      if (pct) pct.textContent = '';
      if (prog) {
        prog.style.strokeDasharray = '';
        prog.style.strokeDashoffset = '';
        prog.style.stroke = '';
      }
    }

    function applyCapacityRingProgress(prog, m) {
      var tot = Math.round(m.tot);
      var used = Math.round(m.used);
      if (tot < 1) tot = 1;
      if (used < 0) used = 0;
      if (used > tot) used = tot;

      /* Ring fill = booked (empty → 0%, sold out → solid). Segmented when tot ≤ 40. */
      if (used <= 0) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '100';
        return;
      }

      if (used >= tot) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '0';
        return;
      }

      if (tot <= 40) {
        var segLen = 100 / tot;
        var gap = Math.min(0.55, segLen * 0.14);
        var draw = Math.max(0.08, segLen - gap);
        var parts = [];
        var empty = Math.max(0, tot - used);
        var i;
        for (i = 0; i < tot; i++) {
          if (i < used) {
            parts.push(draw.toFixed(3), gap.toFixed(3));
          } else {
            parts.push('0', segLen.toFixed(3));
          }
        }
        prog.style.strokeDasharray = parts.join(' ');
        prog.style.strokeDashoffset = '0';
        return;
      }

      var pctExact = (used / tot) * 100;
      pctExact = Math.max(0, Math.min(100, pctExact));
      prog.style.strokeDasharray = '100 100';
      if (pctExact >= 100) {
        prog.style.strokeDashoffset = '0';
      } else if (pctExact <= 0) {
        prog.style.strokeDashoffset = '100';
      } else {
        prog.style.strokeDashoffset = String(pctExact - 100);
      }
    }

    function isHubCapacityDisabled() {
      var HubCity = typeof window !== 'undefined' ? window.WorkshopBookingHubCity : null;
      if (HubCity && typeof HubCity.isHubBooking === 'function') {
        return HubCity.isHubBooking(bookingRoot || wizardRoot);
      }
      return !!(
        (bookingRoot && bookingRoot.getAttribute('data-wb-hub-city-products') === '1') ||
        (wizardRoot && wizardRoot.closest && wizardRoot.closest('[data-wb-hub-city-products="1"]'))
      );
    }

    function syncCapacityRing() {
      var ring = wizardRoot.querySelector('[data-wbw-capacity-ring]');
      if (!ring) return;
      var ringWrap = ring.closest('.wbw-cal-time-row__ring');
      /* Hub: no adapter deploy for capacity_total — hide ring entirely (avoid "—" / partial UI). */
      if (isHubCapacityDisabled()) {
        ring.hidden = true;
        if (ringWrap) ringWrap.hidden = true;
        return;
      }
      if (ringWrap) ringWrap.hidden = false;
      if (state.branch !== 'datetime') {
        ring.hidden = true;
        return;
      }
      ring.hidden = false;
      var m = capacityRingModel(state.selectedSlot);
      if (!m) {
        syncCapacityRingEmpty(ring);
        return;
      }
      if (m.remOnly) {
        ring.classList.remove('is-empty');
        ring.setAttribute('data-capacity-tier', m.rem <= 5 ? 'low' : 'high');
        ring.setAttribute('aria-label', capacityRingAriaLabel(m));
        var fracOnly = ring.querySelector('[data-wbw-cap-frac]');
        var pctOnly = ring.querySelector('[data-wbw-cap-pct]');
        var progOnly = ring.querySelector('.wbw-cal-cap-ring__prog');
        if (fracOnly) fracOnly.textContent = Math.round(m.rem) + ' left';
        if (pctOnly) pctOnly.textContent = '';
        if (progOnly) {
          progOnly.style.strokeDasharray = '100 100';
          progOnly.style.strokeDashoffset = '100';
          progOnly.style.stroke = '';
        }
        return;
      }
      var tier = capacityRingTier(m.pctUsed);
      ring.classList.remove('is-empty');
      ring.setAttribute('data-capacity-tier', tier);
      ring.setAttribute('aria-label', capacityRingAriaLabel(m));
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = Math.round(m.used) + '/' + Math.round(m.tot);
      if (pct) pct.textContent = capacityRingPctText(m);
      if (prog) applyCapacityRingProgress(prog, m);
    }

    function updateSelectionSummary() {
      var wrap = wizardRoot.querySelector('[data-wbw-selection-summary-wrapper]');
      var sum = wizardRoot.querySelector('[data-wbw-selection-summary]');
      if (!wrap || !sum) return;
      var lines = [];
      var slot = state.selectedSlot;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = findWizardVariant(k);
        if (!v) return;
        var label = String(v.label || v.title || 'Workshop').trim();
        var unit = resolveVariantPriceCents(v, slot);
        var lt = unit * q;
        lines.push(
          '<div class="wbw-sel-line">' +
          '<span class="wbw-sel-line__pill">' +
          escapeHtml(String(q) + ' × ' + label) +
          '</span>' +
          '<span class="wbw-sel-line__line-total">' +
          escapeHtml(formatMoney(lt)) +
          '</span></div>'
        );
      });
      var addonQ = state.addonQty || 0;
      if (addonQ > 0) {
        var addonTitle = wbwAddonDisplayTitle(wizardRoot);
        var addonCents = parseInt(wizardRoot.getAttribute('data-addon-price-cents') || '0', 10);
        if (!Number.isFinite(addonCents)) addonCents = 0;
        lines.push(
          '<div class="wbw-sel-line wbw-sel-line--addon">' +
          '<span class="wbw-sel-line__pill">' +
          escapeHtml(String(addonQ) + ' × ' + addonTitle) +
          '</span>' +
          '<span class="wbw-sel-line__line-total">' +
          escapeHtml(formatMoney(addonCents * addonQ)) +
          '</span></div>'
        );
      }
      sum.innerHTML = lines.join('');
    }

    function renderVariants() {
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var slot = state.selectedSlot;
      var eventOpen = slotBookable(slot);

      if (!variants.length) {
        wrap.innerHTML =
          '<div class="wcf-variants-empty"><p class="wcf-variants-empty__text">No workshop styles found for this product.</p></div>';
        updateVariantStepUi();
        return;
      }

      variants.forEach(function (v) {
        var id = vQtyKey(v.id);
        var qty = state.variantQty[id] || 0;
        var row = document.createElement('div');
        row.className = 'wcf-variant-row wbw-variant-row--wizard' + (qty > 0 ? ' is-active' : '');
        row.setAttribute('data-variant-id', id);

        var label = v.label || v.title || 'Workshop';
        var card = document.createElement('div');
        card.className = 'wcf-variant-card';
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', label);
        if (!eventOpen) {
          row.classList.add('is-disabled');
        }
        var imgUrl = v.image_url || '';
        var imgInner = imgUrl
          ? '<img class="wcf-variant-card__img" src="' +
            escapeHtml(imgUrl) +
            '" alt="" width="480" height="480" loading="lazy" decoding="async">'
          : '<div class="wcf-variant-card__img wcf-variant-card__img--placeholder" aria-hidden="true"></div>';
        card.innerHTML =
          '<div class="wcf-variant-card__title">' + escapeHtml(label) + '</div>' +
          '<div class="wcf-variant-card__media">' + imgInner + '</div>' +
          '<div class="wcf-variant-qty-col">' +
          variantQtyControlHtml(id, qty) +
          '</div>' +
          formatWizardVariantPricesOuter(v, slot);

        card.addEventListener('click', function (e) {
          if (!eventOpen) return;
          var inc = e.target.closest('[data-wbw-qty-inc]');
          var dec = e.target.closest('[data-wbw-qty-dec]');
          if (inc || dec) {
            e.preventDefault();
            e.stopPropagation();
            if (dec && dec.disabled) return;
            adjustVariantQty(id, dec ? -1 : 1);
            return;
          }
          if (e.target.closest('[data-wbw-variant-qty]')) return;
          previewWizardVariant(id);
        });

        row.appendChild(card);
        wrap.appendChild(row);
      });

      bindVariantGridResize(wrap, wizardRoot);
      updateVariantStepUi();
    }

    function findWizardVariant(id) {
      var key = vQtyKey(id);
      for (var i = 0; i < variants.length; i++) {
        if (vQtyKey(variants[i].id) === key) return variants[i];
      }
      return null;
    }

    function previewWizardVariant(variantId) {
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      state.focusedVariantId = id;
      if (v) syncVariantToPdp(wizardRoot, data, v);
      syncBookingUrlVariantOnStep3(id);
    }

    function refreshVariantRowUI(variantId) {
      var id = vQtyKey(variantId);
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      var row = wrap.querySelector('.wcf-variant-row[data-variant-id="' + id + '"]');
      if (!row) return;
      var qty = state.variantQty[id] || 0;
      row.classList.toggle('is-active', qty > 0);
      var val = row.querySelector('[data-wbw-qty-val]');
      if (val) val.textContent = String(qty);
      var dec = row.querySelector('[data-wbw-qty-dec]');
      if (dec) dec.disabled = qty <= 0;
      var inc = row.querySelector('[data-wbw-qty-inc]');
      if (inc) {
        var maxTotal = maxBookableQty();
        inc.disabled = Number.isFinite(maxTotal) && totalVariantQty() >= maxTotal;
      }
      var card = row.querySelector('.wcf-variant-card');
      if (card) card.classList.toggle('is-active', qty > 0);
      var vObj = findWizardVariant(id);
      if (vObj) {
        var pricesWrap = row.querySelector('.wcf-variant-card__prices');
        if (pricesWrap) {
          pricesWrap.outerHTML = formatWizardVariantPricesOuter(vObj, state.selectedSlot);
        }
      }
    }

    function adjustVariantQty(variantId, delta) {
      var id = vQtyKey(variantId);
      var cur = state.variantQty[id] || 0;
      var maxTotal = maxBookableQty();
      var others = totalVariantQty() - cur;
      var v = findWizardVariant(id);

      if (delta > 0) {
        if (others >= maxTotal) return;
        state.variantQty[id] = Math.min(cur + 1, maxTotal - others);
        state.focusedVariantId = id;
        if (v) syncVariantToPdp(wizardRoot, data, v);
        syncBookingUrlVariantOnStep3(id);
      } else {
        if (cur <= 1) delete state.variantQty[id];
        else state.variantQty[id] = cur - 1;
        if ((state.variantQty[id] || 0) > 0) {
          state.focusedVariantId = id;
          if (v) syncVariantToPdp(wizardRoot, data, v);
          syncBookingUrlVariantOnStep3(id);
        }
      }
      refreshVariantRowUI(id);
      updateVariantStepUi();
    }

    function computeTotalCents() {
      var total = 0;
      var slot = state.selectedSlot;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === k;
        });
        if (v) total += resolveVariantPriceCents(v, slot) * q;
      });
      if (state.addonQty > 0) {
        total += parseInt(wizardRoot.getAttribute('data-addon-price-cents') || '0', 10) * state.addonQty;
      }
      return total;
    }

    function updateVariantStepUi() {
      var titleEl = wizardRoot.querySelector('[data-wbw-variant-title]');
      if (titleEl) {
        var when = formatBookingSubLabel(state.selectedSlot);
        if (when) {
          titleEl.innerHTML =
            'Choose variant <span class="wbw-variant-title__sep" aria-hidden="true">·</span> <span class="wbw-variant-title__when">' +
            escapeHtml(when) +
            '</span>';
        } else {
          titleEl.textContent = 'Choose variant';
        }
      }
      var tot = wizardRoot.querySelector('[data-wbw-total]');
      if (tot) {
        var cents = computeTotalCents();
        tot.textContent = formatMoney(cents);
      }
      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      if (addBtn) addBtn.disabled = !hasSelectedVariants() || !state.selectedSlot;
      var clearBtn = wizardRoot.querySelector('[data-wbw-action="clear-selection"]');
      if (clearBtn) clearBtn.disabled = !hasSelectedVariants() && !(state.addonQty > 0);
      updateSelectionSummary();
      syncAddonUi();
      syncVenueAddressBlock();
      syncSiblingWorkshopPromo();
    }

    function syncAddonUi() {
      var q = state.addonQty || 0;
      var val = wizardRoot.querySelector('[data-wbw-addon-qty] [data-wbw-qty-val]');
      if (val) val.textContent = String(q);
      var dec = wizardRoot.querySelector('[data-wbw-addon-qty] [data-wbw-qty-dec]');
      if (dec) dec.disabled = q <= 0;
      var inc = wizardRoot.querySelector('[data-wbw-addon-qty] [data-wbw-qty-inc]');
      if (inc) {
        var maxTotal = maxBookableQty();
        inc.disabled =
          Number.isFinite(maxTotal) && totalVariantQty() + q >= maxTotal;
      }
      var addonBtn = wizardRoot.querySelector('[data-wbw-addon]');
      if (addonBtn) {
        addonBtn.classList.toggle('is-selected', q > 0);
        addonBtn.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
      }
      var card = wizardRoot.querySelector('[data-wbw-addon-card]');
      if (card) card.classList.toggle('is-on', q > 0);
    }

    function firstNonEmptyStr() {
      for (var i = 0; i < arguments.length; i++) {
        var s = arguments[i] == null ? '' : String(arguments[i]).trim();
        if (s) return s;
      }
      return '';
    }

    function buildLineItemProperties(slot, variantId, resolvedCents) {
      var raw = (slot && slot._raw) || {};
      var venueObj = state.selectedVenue || {};
      var eventId = String(raw.id || slot.gid || '').trim();
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      var venue = String(raw.venue_name || raw.venue || venueObj.venue_name || '').trim();
      var city = String(raw.city || '').trim();
      var stateCode = String(raw.state || '').trim();
      var datetime = formatBookingSubLabel(slot);
      var displayCity = stateCode ? city + ', ' + stateCode : city;
      var venueAddress = firstNonEmptyStr(
        raw.venue_address,
        raw.address,
        venueObj.venue_address,
        venueObj.address
      );
      var venuePhone = firstNonEmptyStr(raw.venue_phone, raw.phone, venueObj.venue_phone, venueObj.phone);
      var venueHours = firstNonEmptyStr(
        raw.venue_work_hours,
        raw.work_hours,
        venueObj.venue_work_hours,
        venueObj.work_hours
      );
      var props = {
        _workshop: 'true',
        _event_id: eventId,
        _event_metaobject_gid: eventId.indexOf('gid://') === 0 ? eventId : slot.gid || eventId,
        _event_handle: eventHandle,
        _display_city: displayCity,
        _display_venue: venue,
        _display_datetime: datetime,
        _unique: String(variantId) + ':' + eventId,
        _is_workshop: '1',
        'Booking Details': [venue, datetime].filter(Boolean).join(' · '),
      };
      if (venueAddress) props._venue_address = venueAddress;
      if (venuePhone) props._venue_phone = venuePhone;
      if (venueHours) props._venue_hours = venueHours;
      var slotForValidation = Object.assign({}, slot, { gid: slot.gid || eventId });
      var flow = window.WorkshopCityFlow;
      if (flow && typeof flow.appendCartValidationProperties === 'function') {
        props = flow.appendCartValidationProperties(slotForValidation, props);
      } else {
        var cap = slot && slot.capacity_remaining;
        if (cap != null && cap !== '') {
          var cn = Number(cap);
          if (Number.isFinite(cn) && cn >= 0) {
            props._capacity_remaining = String(cn);
            props._capacity_source = 'wizard_slot';
          }
        }
      }
      var centsStr = String(resolvedCents == null ? '' : resolvedCents).trim();
      if (/^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0) {
        props._resolved_price_cents = centsStr;
        props._resolved_price = centsStr;
      }
      return props;
    }

    var wlFieldErrorTimers = {};

    function clearWlFieldErrors(step) {
      if (!step) return;
      step.querySelectorAll('[data-wbw-wl-field-hint]').forEach(function (hint) {
        hint.hidden = true;
        hint.textContent = '';
      });
      step.querySelectorAll('.wcf-field--err').forEach(function (field) {
        field.classList.remove('wcf-field--err');
      });
    }

    function showWlFieldError(input, message) {
      if (!input || !message) return;
      var field = input.closest('.wcf-field');
      if (!field) return;
      var key =
        input.getAttribute('data-wbw-wl-name') || input.getAttribute('data-wbw-wl-modal-name')
          ? 'name'
          : input.getAttribute('data-wbw-wl-email') || input.getAttribute('data-wbw-wl-modal-email')
            ? 'email'
            : 'other';
      if (wlFieldErrorTimers[key]) {
        clearTimeout(wlFieldErrorTimers[key]);
        wlFieldErrorTimers[key] = null;
      }
      var hint = field.querySelector('[data-wbw-wl-field-hint]');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'wcf-field-hint wcf-field-hint--err';
        hint.setAttribute('data-wbw-wl-field-hint', '');
        hint.setAttribute('role', 'alert');
        field.appendChild(hint);
      }
      hint.textContent = message;
      hint.hidden = false;
      field.classList.add('wcf-field--err');
      input.setAttribute('aria-invalid', 'true');
      wlFieldErrorTimers[key] = window.setTimeout(function () {
        hint.hidden = true;
        hint.textContent = '';
        field.classList.remove('wcf-field--err');
        input.removeAttribute('aria-invalid');
        wlFieldErrorTimers[key] = null;
      }, 2000);
    }

    function submitWaitlist() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal].is-open');
      var step = modal || stepEl('waitlist');
      if (!step) return;
      var nameIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-name]' : '[data-wbw-wl-name]'
      );
      var emailIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-email]' : '[data-wbw-wl-email]'
      );
      var notesIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-notes]' : '[data-wbw-wl-notes]'
      );
      var errEl = step.querySelector(modal ? '[data-wbw-wl-modal-error]' : '[data-wbw-wl-error]');
      var okEl = step.querySelector(modal ? '[data-wbw-wl-modal-success]' : '[data-wbw-wl-success]');
      var subBtn = modal
        ? modal.querySelector('[data-wbw-action="wl-submit"]')
        : step.querySelector('[data-wbw-action="wl-submit"]');
      if (errEl) errEl.hidden = true;
      if (okEl) okEl.hidden = true;
      clearWlFieldErrors(step);

      var fullName = nameIn ? String(nameIn.value || '').trim() : '';
      var email = emailIn ? String(emailIn.value || '').trim() : '';
      var notes = notesIn ? String(notesIn.value || '').trim() : '';
      var parts = splitFullName(fullName);

      if (!fullName) {
        showWlFieldError(nameIn, 'Please enter your name.');
        if (nameIn && nameIn.focus) nameIn.focus();
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showWlFieldError(emailIn, 'Please enter a valid email.');
        if (emailIn && emailIn.focus) emailIn.focus();
        return;
      }

      var venue = state.selectedVenue || {};
      var venueRefId = venue.venue_ref_id != null ? String(venue.venue_ref_id).trim() : '';
      var venueTitle = (venue.venue_name || venue.name || '').trim();
      var loc = (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.label) || '';
      if (!loc && bookingRoot) {
        var inp = bookingRoot.querySelector('[data-workshop-location-input]');
        if (inp) loc = String(inp.value || '').trim();
      }
      var cityForAddress = '';
      if (loc) {
        var addrParts = loc.split(',');
        if (addrParts[0]) cityForAddress = String(addrParts[0]).trim();
      }
      if (!cityForAddress && venueTitle) cityForAddress = venueTitle;

      if (subBtn) subBtn.disabled = true;

      resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data)
        .then(function (workshopType) {
          if (!workshopType) {
            throw new Error(
              'Workshop type could not be determined. Add a product tag (mosaic, ceramic, resin, or flower) or set Workshop type in the booking block settings.'
            );
          }

          var payload = {
            email: email,
            first_name: parts.first,
            last_name: parts.last,
            name: fullName,
            location: loc,
            venue_id: venueRefId,
            venue_name: venueTitle,
            notes: notes,
            shop_domain: window.Shopify && window.Shopify.shop ? String(window.Shopify.shop).trim() : '',
            workshop_type: workshopType,
          };
          if (cityForAddress) {
            payload.city = cityForAddress;
            payload.country = 'New Zealand';
            payload.country_code = 'NZ';
          }

          var url =
            typeof window.__WB_WAITLIST_API_URL__ === 'string' && window.__WB_WAITLIST_API_URL__.trim()
              ? window.__WB_WAITLIST_API_URL__.trim()
              : 'https://adapter.aogen.com.au/api/public/waitlist';

          var submitFn = Flow && Flow.submitWaitlist ? Flow.submitWaitlist : null;
          return submitFn
            ? submitFn(url, payload)
            : fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload),
                mode: 'cors',
              }).then(function (res) {
                if (res.ok) return;
                return res.text().then(function (txt) {
                  throw new Error(txt || 'Request failed');
                });
              });
        })
        .then(function () {
          if (okEl) okEl.hidden = false;
          if (modal) {
            window.setTimeout(function () {
              closeWizardWaitlistModal();
            }, 2200);
          }
        })
        .catch(function (err) {
          if (errEl) {
            errEl.textContent = err && err.message ? String(err.message).slice(0, 200) : 'Something went wrong.';
            errEl.hidden = false;
          }
        })
        .finally(function () {
          if (subBtn) subBtn.disabled = false;
        });
    }

    function submitCartForSlot(slot, addBtn) {
      if (!slot || !hasSelectedVariants()) return Promise.resolve();
      var HubCity = typeof window !== 'undefined' ? window.WorkshopBookingHubCity : null;
      var isHub =
        HubCity && typeof HubCity.isHubBooking === 'function'
          ? HubCity.isHubBooking(bookingRoot || wizardRoot)
          : false;
      var sellHandle = '';
      if (isHub) {
        var venueObj = state.selectedVenue || {};
        var rawSlot = (slot && slot._raw) || {};
        sellHandle = String(
          venueObj._wbHubProductHandle ||
            rawSlot.product_handle ||
            (state.selectedVenueCard &&
              state.selectedVenueCard._wbVenue &&
              state.selectedVenueCard._wbVenue._wbHubProductHandle) ||
            ''
        ).trim();
        if (!sellHandle) {
          var hubH = String(
            data.productHandle || wizardRoot.getAttribute('data-product-handle') || ''
          )
            .trim()
            .toLowerCase();
          var citySlug = String(venueObj.venue_name || venueObj.city_name || venueObj.city || '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          if (hubH && citySlug) sellHandle = hubH + '-in-' + citySlug;
        }
      }

      var lineJobs = [];
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var vid = parseInt(k, 10);
        if (!Number.isFinite(vid) || vid <= 0) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === k;
        });
        var resolved = v ? resolveVariantPriceCents(v, slot) : 0;
        var handle = String((slot._raw && slot._raw.handle) || slot.handle || '');
        if (/^\d+$/.test(handle) || !handle) {
          window.alert('This workshop event is not available for booking. Please select a different time.');
          return;
        }
        var job = Promise.resolve({
          vid: vid,
          quantity: q,
          resolved: resolved,
          hubVid: vid,
        });
        if (isHub && HubCity && typeof HubCity.resolveCitySellVariant === 'function') {
          var kitLabel = String((v && (v.label || v.title)) || '').trim();
          job = HubCity.resolveCitySellVariant({
            productHandle: sellHandle,
            label: kitLabel,
          }).then(function (sell) {
            if (!sell || !sell.matched || !sell.variantId) {
              var err = new Error('hub_sell_remap_failed');
              err.kitLabel = kitLabel;
              err.sellHandle = sellHandle;
              throw err;
            }
            var sellNum = parseInt(String(sell.variantId), 10);
            if (!Number.isFinite(sellNum) || sellNum <= 0) {
              throw new Error('hub_sell_remap_invalid');
            }
            if (window.__WB_DIAG__) {
              console.log('[WBW] hub→city sell remap', {
                hubVariantId: vid,
                sellVariantId: sellNum,
                label: kitLabel,
                handle: sellHandle,
              });
            }
            return {
              vid: sellNum,
              quantity: q,
              resolved: sell.priceCents != null && sell.priceCents > 0 ? sell.priceCents : resolved,
              hubVid: vid,
            };
          });
        }
        lineJobs.push(job);
      });

      if (!lineJobs.length) return Promise.resolve();

      return Promise.all(lineJobs)
        .then(function (lines) {
          var items = lines.map(function (line) {
            return {
              id: line.vid,
              quantity: line.quantity,
              properties: buildLineItemProperties(slot, line.vid, line.resolved),
            };
          });

          var addonId = wizardRoot.getAttribute('data-addon-variant-id');
          if (state.addonQty > 0 && addonId) {
            var aid = parseInt(addonId, 10);
            if (Number.isFinite(aid) && aid > 0) {
              items.push({
                id: aid,
                quantity: state.addonQty,
                properties: {
                  _workshop_addon: 'true',
                  _addon_for_event_id: String((slot._raw && slot._raw.id) || slot.gid || ''),
                  _addon_title: wbwAddonDisplayTitle(wizardRoot),
                },
              });
            }
          }
          if (!items.length) return null;

          var payload = { items: items };
          if (Flow && Flow.getCartSections) {
            var sections = Flow.getCartSections();
            if (sections.length) {
              payload.sections = sections.join(',');
              payload.sections_url = (window.location && window.location.pathname) || '/';
            }
          }
          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }).then(function (res) {
            return res.json().then(function (body) {
              return { ok: res.ok, body: body };
            });
          });
        })
        .then(function (r) {
          if (!r) return;
          if (!r.ok || (r.body && r.body.status === 422)) {
            window.alert((r.body && r.body.description) || 'Unable to add to cart.');
            return;
          }
          if (Flow && Flow.dispatchCartUi) Flow.dispatchCartUi(r.body);
          else {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: r.body } }));
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
          if (addBtn) addBtn.textContent = 'Added';
        })
        .catch(function (err) {
          if (err && String(err.message || '').indexOf('hub_sell_remap') === 0) {
            window.alert('Could not map kit to city product. Please reselect venue and kit.');
            if (window.__WB_DIAG__) console.warn('[WBW] hub sell remap failed', err);
            return;
          }
          window.alert('Unable to add to cart.');
        });
    }

    function addToCart() {
      if (!state.selectedSlot || !hasSelectedVariants()) return;
      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }
      var freshPromise =
        liveController && typeof liveController.ensureFreshSlot === 'function'
          ? liveController.ensureFreshSlot(state.selectedSlot)
          : Promise.resolve(state.selectedSlot);
      freshPromise
        .then(function (freshSlot) {
          if (!freshSlot || !slotBookable(freshSlot)) {
            window.alert('This workshop event is sold out. Please select a different time.');
            return null;
          }
          state.selectedSlot = freshSlot;
          replaceSelectedSlotFromList([freshSlot]);
          renderVariants();
          syncCapacityRing();
          var addQty = totalVariantQty();
          var validatePromise;
          if (liveController && typeof liveController.validateSlotForCart === 'function') {
            validatePromise = liveController.validateSlotForCart(freshSlot, addQty);
          } else {
            var liveApi = getLiveApi();
            if (liveApi && typeof liveApi.validateAddToCart === 'function') {
              validatePromise = liveApi.validateAddToCart(freshSlot, addQty, { intent: 'add_to_cart' });
            } else {
              validatePromise = Promise.resolve({
                allowed: false,
                message: 'We could not verify workshop availability. Please try again.',
              });
            }
          }
          return validatePromise.then(function (verdict) {
            if (!verdict || verdict.allowed === false) {
              window.alert(
                (verdict && verdict.message) ||
                  'This workshop event is no longer available. Please select a different time.'
              );
              return null;
            }
            return freshSlot;
          });
        })
        .then(function (freshSlot) {
          if (!freshSlot) return;
          return submitCartForSlot(freshSlot, addBtn);
        })
        .catch(function () {
          window.alert('Unable to confirm workshop availability. Please try again.');
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = !hasSelectedVariants();
            addBtn.textContent = 'Add to cart';
          }
        });
    }

    wizardRoot.addEventListener('click', function (e) {
      var act = e.target.closest('[data-wbw-action]');
      if (act) {
        var action = act.getAttribute('data-wbw-action');
        if (action === 'to-next') {
          e.preventDefault();
          goToNextFromVenue();
          return;
        }
        if (action === 'to-variants') {
          e.preventDefault();
          if (!state.selectedSlot) return;
          closeCalTimeDd();
          ensureLockedVariantFromUrlOrSlot(state.selectedSlot);
          syncBookingUrlForDatetimeStep(state.selectedSlot);
          setBranch('variants');
          renderVariants();
          return;
        }
        if (action === 'back') {
          e.preventDefault();
          if (state.branch === 'variants') {
            setBranch('datetime');
            renderCalendar();
            if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
            else clearBookingUrlEventIdKeepVariant();
          } else if (state.branch === 'datetime' || state.branch === 'waitlist') {
            setBranch('venue');
          }
          return;
        }
        if (action === 'clear-selection') {
          e.preventDefault();
          state.variantQty = {};
          state.addonQty = 0;
          renderVariants();
          return;
        }
        if (action === 'add-cart') {
          e.preventDefault();
          addToCart();
          return;
        }
        if (action === 'wl-submit') {
          e.preventDefault();
          submitWaitlist();
          return;
        }
      }

      var calDay = e.target.closest('[data-wbw-cal-day]');
      if (calDay && !calDay.disabled && stepEl('datetime') && stepEl('datetime').contains(calDay)) {
        state.selectedDate = calDay.getAttribute('data-wbw-cal-day') || '';
        state.selectedSlot = null;
        clearBookingUrlEventIdKeepVariant();
        renderCalendar();
        return;
      }

      if (e.target.closest('[data-wbw-cal-prev]')) {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() - 1, 1);
        ensureHubMonthThenRender();
        return;
      }
      if (e.target.closest('[data-wbw-cal-next]')) {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + 1, 1);
        ensureHubMonthThenRender();
        return;
      }

      if (e.target.closest('[data-wbw-addon]')) {
        e.preventDefault();
        state.addonQty = state.addonQty > 0 ? 0 : 1;
        syncAddonUi();
        updateVariantStepUi();
        if (isMobileViewport()) {
          var addonCard = wizardRoot.querySelector('[data-wbw-addon-card]');
          if (addonCard && addonCard.__wbwShowMobilePreview) {
            addonCard.__wbwShowMobilePreview(e);
          }
        }
        return;
      }

      var inc = e.target.closest('[data-wbw-qty-inc]');
      var dec = e.target.closest('[data-wbw-qty-dec]');
      if ((inc || dec) && e.target.closest('[data-wbw-addon-qty]')) {
        e.preventDefault();
        var cur = state.addonQty || 0;
        var maxTotal = maxBookableQty();
        var next = cur + 1;
        if (Number.isFinite(maxTotal)) next = Math.min(next, maxTotal);
        state.addonQty = dec ? Math.max(0, cur - 1) : next;
        syncAddonUi();
        updateVariantStepUi();
      }
    });

    window.addEventListener(
      'resize',
      function () {
        var wrap = wizardRoot.querySelector('[data-wbw-variants]');
        if (wrap && wrap.querySelectorAll('.wcf-variant-row').length) {
          applyVariantGridLayout(wrap, wrap.querySelectorAll('.wcf-variant-row').length, wizardRoot);
        }
      },
      { passive: true }
    );

    function findVenueCardByRef(venueRefId) {
      if (!eventsRoot || !venueRefId) return null;
      var ref = String(venueRefId).trim();
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var i = 0; i < cards.length; i++) {
        if (String(cards[i].getAttribute('data-venue-ref-id') || '').trim() === ref) {
          return cards[i];
        }
      }
      return null;
    }

    function findDeepLinkEventMatch(urlEventId) {
      if (!urlEventId) return null;
      var urlNumeric =
        extractNumericEventIdForUrl(urlEventId) || normalizeEventIdForMatch(urlEventId);
      if (!urlNumeric) return null;

      function matchFromVenue(venue, card) {
        if (!venue || !Array.isArray(venue.events)) return null;
        for (var ei = 0; ei < venue.events.length; ei++) {
          var ev = venue.events[ei];
          if (!eventRecordMatchesUrlEventId(ev, urlNumeric)) continue;
          var slot = normalizeEventToSlot(ev);
          if (!slot || !slot.date_key) continue;
          var resolvedCard = card;
          if (!resolvedCard && venue.venue_ref_id) {
            resolvedCard = findVenueCardByRef(venue.venue_ref_id);
          }
          if (!resolvedCard && eventsRoot) {
            var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
            for (var c = 0; c < cards.length; c++) {
              if (cards[c]._wbVenue === venue) {
                resolvedCard = cards[c];
                break;
              }
            }
          }
          if (!resolvedCard) return null;
          return { card: resolvedCard, venue: venue, slot: slot };
        }
        return null;
      }

      var list = typeof window !== 'undefined' ? window.__WORKSHOP_VENUE_LIST__ : null;
      if (list && Array.isArray(list.groups)) {
        for (var g = 0; g < list.groups.length; g++) {
          var venues = list.groups[g].venues || [];
          for (var v = 0; v < venues.length; v++) {
            var hit = matchFromVenue(venues[v], findVenueCardByRef(venues[v].venue_ref_id));
            if (hit) return hit;
          }
        }
      }

      if (!eventsRoot) return null;
      var domCards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var dc = 0; dc < domCards.length; dc++) {
        var hitDom = matchFromVenue(domCards[dc]._wbVenue, domCards[dc]);
        if (hitDom) return hitDom;
      }
      return null;
    }

    function applyDeepLinkMatch(match, mode) {
      if (!match || !match.card || !match.slot) return false;
      selectVenueCard(match.card);
      if (state.flow === 'waitlist') return false;

      if (mode === 'event_step2') {
        startDatetimeStep(match.slot);
        return true;
      }

      if (mode === 'variant_step3') {
        startDatetimeStep(match.slot);
        var variantParam = getVariantIdFromUrl();
        if (variantParam) {
          var vKey = vQtyKey(variantParam);
          var vObj = findWizardVariant(vKey);
          if (vObj) {
            state.variantQty = {};
            state.variantQty[vKey] = 1;
            state.focusedVariantId = vKey;
            syncVariantToPdp(wizardRoot, data, vObj);
          }
        }
        closeCalTimeDd();
        setBranch('variants');
        renderVariants();
        return true;
      }
      return false;
    }

    function canonicalizeWizardBookingUrl() {
      var v = getVariantIdFromUrl();
      var e = getEventIdFromUrl();
      if (!v && !e) return;
      var patch = {};
      if (e) patch.eventId = e;
      if (v) patch.variantId = v;
      updateWizardBookingUrl(patch);
    }

    function tryApplyUrlDeepLink() {
      if (urlDeepLinkApplied) return;
      var mode = urlDeepLinkMode;
      if (!mode || mode === 'none') return;

      var urlEventId = getEventIdFromUrl();
      if (!urlEventId) return;

      var match = findDeepLinkEventMatch(urlEventId);
      if (!match || !match.card || !match.slot) return;

      if (applyDeepLinkMatch(match, mode)) {
        urlDeepLinkApplied = true;
        canonicalizeWizardBookingUrl();
        try {
          wizardRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_) {}
      }
    }

    wizardRoot.__wbwTryDeepLink = tryApplyUrlDeepLink;

    function onVenueListRenderedForDeepLink(e) {
      var detail = (e && e.detail) || {};
      if (detail.bookingRoot && bookingRoot && detail.bookingRoot !== bookingRoot) return;
      tryApplyUrlDeepLink();
    }

    bindVenueSelection();
    document.addEventListener('wbw:venue-reset', onVenueResetEvent);
    document.addEventListener('wbw:venue-list-rendered', onVenueListRenderedForDeepLink);
    bindCalTimeControls();
    if (bookingRoot) {
      bindWizardSearchLayout(bookingRoot);
    }
    bindAddonHoverPreview(wizardRoot);
    wizardRoot.setAttribute('data-wbw-flow', 'booking');
    updateVenueContinue();
    tryApplyUrlDeepLink();
    if (!urlDeepLinkApplied) {
      setBranch('venue');
    }
    updateProgressLabels();
    canonicalizeWizardBookingUrl();
    var deepLinkDelays = [150, 400, 900, 1800];
    deepLinkDelays.forEach(function (ms) {
      setTimeout(function () {
        if (urlDeepLinkApplied) return;
        tryApplyUrlDeepLink();
        if (!urlDeepLinkApplied) return;
        canonicalizeWizardBookingUrl();
      }, ms);
    });
  }

  function boot() {
    document.querySelectorAll('[data-workshop-booking-wizard]').forEach(initRoot);
    if (typeof window.__wbwApplyAllDeepLinks === 'function') {
      window.__wbwApplyAllDeepLinks();
    }
  }

  window.__wbwApplyAllDeepLinks = function () {
    document.querySelectorAll('[data-workshop-booking-wizard]').forEach(function (root) {
      if (typeof root.__wbwTryDeepLink === 'function') root.__wbwTryDeepLink();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
